// Generated by Avo VERSION 168.76.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function () {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj: any) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function (obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name: any) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value: any) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items: any) {
    var iterator: any = {
      next: function () {
        var value = items.shift();
        return { done: value === undefined, value: value }
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers: any) {
    // @ts-ignore
    (this as any).map = {};

    if (headers instanceof Headers) {
      (headers as any).forEach(function (value: any, name: any) {
        // @ts-ignore
        this.append(name, value);
        // @ts-ignore
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header: any) {
        // @ts-ignore
        this.append(header[0], header[1]);
        // @ts-ignore
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name: any) {
        // @ts-ignore
        this.append(name, headers[name]);
        // @ts-ignore
      }, this);
    }
  }

  Headers.prototype.append = function (name: any, value: any) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function (name: any) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name: any) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function (name: any) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function (name: any, value: any) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback: any, thisArg: any) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items: any = [];
    this.forEach(function (_value: any, name: any) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function () {
    var items: any = [];
    this.forEach(function (value: any) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function () {
    var items: any = [];
    this.forEach(function (value: any, name: any) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body: any) {
    if (body.bodyUsed) {
      return true;
    }
    body.bodyUsed = true;
    return false;
  }

  function fileReaderReady(reader: any) {
    return new Promise(function (resolve: any, reject: any) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf: any) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]!);
    }
    return chars.join('')
  }

  function bufferClone(buf: any) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    // @ts-ignore
    (this as any).bodyUsed = false;

    // @ts-ignore
    (this as any)._initBody = function (body: any) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      // @ts-ignore
      (this as any).blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return Promise.reject(new TypeError('Already read'));
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      // @ts-ignore
      (this as any).arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          if (consumed(this)) {
            return Promise.reject(new TypeError('Already read'));
          } else {
            return Promise.resolve(this._bodyArrayBuffer);
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    // @ts-ignore
    (this as any).text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return Promise.reject(new TypeError('Already read'));
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      // @ts-ignore
      (this as any).formData = function () {
        return this.text().then(decode)
      };
    }

    // @ts-ignore
    (this as any).json = function () {
      return this.text().then(JSON.parse)
    };

    // @ts-ignore
    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method: any) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input: any, options: any) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if ((input as any).bodyUsed) {
        throw new TypeError('Already read')
      }
      // @ts-ignore
      (this as any).url = (input as any).url;
      // @ts-ignore
      this.credentials = (input as any).credentials;
      if (!options.headers) {
        // @ts-ignore
        this.headers = new Headers((input as any).headers);
      }
      // @ts-ignore
      this.method = (input as any).method;
      // @ts-ignore
      this.mode = (input as any).mode;
      // @ts-ignore
      this.signal = (input as any).signal;
      if (!body && (input as any)._bodyInit != null) {
        body = (input as any)._bodyInit;
        (input as any).bodyUsed = true;
      }
    } else {
      // @ts-ignore
      this.url = String(input);
    }

    // @ts-ignore
    this.credentials = options.credentials || this.credentials || 'same-origin';
    // @ts-ignore
    if (options.headers || !this.headers) {
      // @ts-ignore
      this.headers = new Headers(options.headers);
    }
    // @ts-ignore
    this.method = normalizeMethod(options.method || this.method || 'GET');
    // @ts-ignore
    this.mode = options.mode || this.mode || null;
    // @ts-ignore
    this.signal = options.signal || this.signal;
    // @ts-ignore
    this.referrer = null;

    // @ts-ignore
    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    // @ts-ignore
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    // @ts-ignore
    return new Request(this, { body: this._bodyInit })
  };

  function decode(body: any) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function (bytes: any) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders: any) {
    // @ts-ignore
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function (line: any) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit: any, options: any) {
    if (!options) {
      options = {};
    }

    // @ts-ignore
    this.type = 'default';
    // @ts-ignore
    this.status = options.status === undefined ? 200 : options.status;
    // @ts-ignore
    this.ok = this.status >= 200 && this.status < 300;
    // @ts-ignore
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    // @ts-ignore
    this.headers = new Headers(options.headers);
    // @ts-ignore
    this.url = options.url || '';
    // @ts-ignore
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    // @ts-ignore
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      // @ts-ignore
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function () {
    // @ts-ignore
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url: any, status: any) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    // @ts-ignore
    return new Response(null, { status: status, headers: { location: url } })
  };

  (self as any).DOMException = (self as any).DOMException;
  try {
    new (self as any).DOMException();
  } catch (err) {
    (self as any).DOMException = function (message: any, name: any) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    (self as any).DOMException.prototype = Object.create(Error.prototype);
    (self as any).DOMException.prototype.constructor = (self as any).DOMException;
  }

  function fetch(input: any, init: any) {
    return new Promise(function (resolve, reject) {
      // @ts-ignore
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new (self as any).DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        (options as any).url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : (xhr as any).responseText;
        // @ts-ignore
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function () {
        reject(new (self as any).DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value: any, name: any) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function () {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    (self as any).fetch = fetch;
    (self as any).Headers = Headers;
    (self as any).Request = Request;
    (self as any).Response = Response;
  }
})();

export enum AvoEnv {
  Prod = "prod",
  Dev = "dev",
}

export interface CustomDestination {
  make?(env: AvoEnv, apiKey: string): void;
  logEvent?: (eventName: string, eventProperties: Record<string, any>) => void;
  setUserProperties?: (userId: string, userProperties: Record<string, any>) => void;
  identify?: (userId: string) => void;
  unidentify?: () => void;
  logPage?: (pageName: string, eventProperties: Record<string, any>) => void;
  revenue?: (amount: number, eventProperties: Record<string, any>) => void;
  setGroupProperties?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  addCurrentUserToGroup?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  logEventWithGroups?: (
    eventName: string,
    eventProperties: any,
    groupTypesToGroupIds: Record<string, string>,
  ) => void;
}

// @ts-ignore
interface AvoAssertMessage {
  eventName?: string;
  tag?: string;
  propertyId?: string;
  message?: string;
  additionalProperties?: string[],
  shape?: any,
  shapeUserProps?: any,
  actualType?: string
}

let __AVO_ENV__: AvoEnv | null = null;
// @ts-ignore
let __AVO_NOOP__: boolean = false;
// @ts-ignore
let __AVO_LOGGER__: AvoLogger | null = null;
// @ts-ignore
let __STRICT__: boolean | null = null;
// @ts-ignore
let __REPORT_FAILURE_AS__: 'error' | 'warn' | 'log' | null = null;

// @ts-ignore
let __WEB_DEBUGGER__: boolean = true;
export const avoInspectorApiKey = "uWEQVlP8vGah1z65ZpfJ";
// @ts-ignore
interface AvoInspector {}
let __INSPECTOR__: AvoInspector | null = null;


// polyfill Object.assign
// @ts-ignore
declare interface ObjectConstructor {
  assign: any;
}
// @ts-ignore
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target: any, _varArgs: any) { // .length of function is 2
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      let to = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        let nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (let nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

interface AvoLogger {
  logDebug(env: AvoEnv | null, message: string): boolean;
  logWarn(env: AvoEnv | null, message: string): boolean;
  logError(env: AvoEnv | null, error: string): boolean;
}

enum webDebuggerArea {
  BottomRight = "BottomRight",
  BottomLeft = "BottomLeft",
  TopRight = "TopRight",
  TopLeft = "TopLeft"
}

interface bottomRightParameters {
  bottom: number;
  right: number;
}

interface bottomLeftParameters {
  bottom: number;
  left: number;
}

interface topRightParameters {
  top: number;
  right: number;
}

interface topLeftParameters {
  top: number;
  left: number;
}

interface webDebuggerPosition {
  position: webDebuggerArea;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}

interface webDebuggerOptions {
  position?: webDebuggerPosition;
}

interface WebDebuggerPositionSetter {
  BottomRight(p: bottomRightParameters): webDebuggerPosition;
  BottomLeft(p: bottomLeftParameters): webDebuggerPosition;
  TopRight(p: topRightParameters): webDebuggerPosition;
  TopLeft(p: topLeftParameters): webDebuggerPosition;
}

export const WebDebuggerPosition: WebDebuggerPositionSetter = {
  BottomRight: ({ bottom, right }) => ({
    position: webDebuggerArea.BottomRight,
    bottom,
    right,
  }),
  BottomLeft: ({ bottom, left }) => ({
    position: webDebuggerArea.BottomLeft,
    bottom,
    left,
  }),
  TopRight: ({ top, right }) => ({
    position: webDebuggerArea.TopRight,
    top,
    right,
  }),
  TopLeft: ({ top, left }) => ({
    position: webDebuggerArea.TopLeft,
    top,
    left,
  }),
}


let InternalAvoLogger: any = {
  logEventSent: function logEventSent(eventName: string, eventProperties: any, userProperties: any) {
    const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties);

    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties);
  },

  log: function log(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] " + message);
  },

  warn: function warn(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.warn("[avo] " + message);
  },

  error: function error(message: string, error: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
      return
    }
    typeof console !== 'undefined' && console.error("[avo] " + message, error);
  }
};

function convertPropertiesArrayToMap(propertiesArray: [{id: string, name: string, value: string}]): {string: string | null | undefined} {
    let result: {string: string} = {}

    propertiesArray.forEach(value => {
      result[value.name] = value.value
    })

    return result
}

// @ts-ignore
let array_difference: any;
// @ts-ignore
let AvoAssert: any;
array_difference = function array_difference(a1: any[], a2: any[]) {
  let result: any[] = [];
  for (let i = 0; i < a1.length; i++) {
    if (a2.indexOf(a1[i]) === -1) {
      result.push(a1[i]);
    }
  }
  return result;
}

AvoAssert = {
  assertObject: function assertObject(propertyId: string, propName: string, obj: any) {
    if (typeof obj !== 'object') {
      let message = propName +
          ' should be of type object but you provided type ' +
          typeof obj +
          ' with value ' +
          JSON.stringify(obj);
      return [{tag: 'expectedObjectType', propertyId, message, actualType: typeof obj}];
    } else {
      return [];
    }
  },

  assertString: function assertString(propertyId: string, propName: string, str: string) {
    if (typeof str !== 'string') {
      let message = propName +
          ' should be of type string but you provided type ' +
          typeof str +
          ' with value ' +
          JSON.stringify(str);
      return [{tag: 'expectedStringType', propertyId, message, actualType: typeof str}];
    } else {
      return [];
    }
  },

  assertInt: function assertInt(propertyId: string, propName: string, int: number) {
    if (typeof int === 'number' && int !== Math.round(int)) {
      let message = propName +
          ' should be of type int but you provided type float with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: 'float'}];
    } else if (typeof int !== 'number') {
      let message = propName +
          ' should be of type int but you provided type ' +
          typeof int +
          ' with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: typeof int}];
    } else {
      return [];
    }
  },

  assertLong: function assertLong(propertyId: string, propName: string, long: number) {
    if (typeof long === 'number' && long !== Math.round(long)) {
      let message = propName +
          ' should be of type long but you provided type float with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: 'float'}];
    } else if (typeof long !== 'number') {
      let message = propName +
          ' should be of type long but you provided type ' +
          typeof long +
          ' with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: typeof long}];
    } else {
      return [];
    }
  },

  assertFloat: function assertFloat(propertyId: string, propName: string, float: number) {
    if (typeof float !== 'number') {
      let message = propName +
          ' should be of type float but you provided type ' +
          typeof float +
          ' with value ' +
          JSON.stringify(float);
      return [{tag: 'expectedFloatType', propertyId, message, actualType: typeof float}];
    } else {
      return [];
    }
  },

  assertBool: function assertBool(propertyId: string, propName: string, bool: boolean) {
    if (typeof bool !== 'boolean') {
      let message = propName +
          ' should be of type boolean but you provided type ' +
          typeof bool +
          ' with value ' +
          JSON.stringify(bool);
      return [{tag: 'expectedBoolType', propertyId, message, actualType: typeof bool}];
    } else {
      return [];
    }
  },

  assertMax: function assertMax(
    propertyId: string,
    propName: string,
    max: number,
    value: number
  ) {
    if (value > max) {
      let message = propName +
        ' has a maximum value of ' +
        max +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMax', propertyId, message}];
    } else {
      return [];
    }
  },

  assertMin: function assertMin(
    propertyId: string,
    propName: string,
    min: number,
    value: number
  ) {
    if (value < min) {
      let message = propName +
        ' has a minimum value of ' +
        min +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMin', propertyId, message}];
    } else {
      return [];
    }
  },

  assertList: function assertList(propertyId: string, propName: string, value: any) {
    if (!Array.isArray(value)) {
      let message = propName + ' should be of type list but you provided type ' + typeof value;
      return [{tag: 'expectedList', propertyId, message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalUserProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional user properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },
};

let _avo_invoke: any;
let _avo_invoke_meta: any;
let _avo_sampling_rate = 1.0;
_avo_invoke = function _avo_invoke(env: AvoEnv, eventId: string, hash: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "yiLAytduN09Ssf7sOkUf",
          "br": "master",
          "en": env,
          "ev": eventId,
          "ha": hash,
          "sc": "rnvgiYxmtEqBZwPzQZWl",
          "se": (new Date()).toISOString(),
          "so": "YEDbyu_hwp",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}

_avo_invoke_meta = function _avo_invoke_meta(env: AvoEnv, type: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "yiLAytduN09Ssf7sOkUf",
          "br": "master",
          "en": env,
          "ty": type,
          "sc": "rnvgiYxmtEqBZwPzQZWl",
          "se": (new Date()).toISOString(),
          "so": "YEDbyu_hwp",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}


let _avo_debugger_log: any;
let _avo_debugger_events_during_boot: any = [];
let _avo_debugger_ready = false;

if (typeof (window as any) !== 'undefined') {
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    let iframe: any = document.getElementById("avo-debugger");
    if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
      let message = {
        type_: "avo-debugger-boot-events",
        schemaId: "rnvgiYxmtEqBZwPzQZWl",
        href: window.location.href,
        events: _avo_debugger_events_during_boot
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(eventId: string, eventName: string, messages: any[], eventProperties: any[], userProperties: any[], groupProperties: any[]) {
  if (typeof (window as any) === 'undefined') { return; }
  let event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties,
    userProperties,
    groupProperties
  };

  if (_avo_debugger_ready) {
    let message = {type_: "avo-debugger-events", events: [event]};
    (document.getElementById("avo-debugger") as any).contentWindow.postMessage(message, "https://www.avo.app/_debugger")
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
}

function _avo_debugger_send_position(position: webDebuggerPosition) {
  if (typeof window === 'undefined') { return; }
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    if (event.data.type_ === "avo-debugger-ready" && position !== null) {
      var message = {type_: "avo-debugger-position", position: position};
      document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  })
}


export interface Sorts {
}

export interface Products {
}

export interface Filters {
}

let Segment: any;

export function initAvo(options: {env: AvoEnv;
    webDebugger?: boolean;
    webDebuggerOptions?: webDebuggerOptions;
    strict?: boolean;
    noop?: boolean;
    reportFailureAs?: 'error' | 'warn' | 'log';
    inspector?: AvoInspector;
    avoLogger?: AvoLogger},
    destinationOptions: any,
    SegmentDestination: CustomDestination) {
if (__AVO_ENV__ !== null) {
  return;
}
__AVO_ENV__ = options.env;
if (options.avoLogger !== undefined) {
  __AVO_LOGGER__ = options.avoLogger;
}
if (options.noop === true) {
  __AVO_NOOP__ = true;
}
if (__AVO_NOOP__ && __AVO_ENV__ == AvoEnv.Prod) {
  InternalAvoLogger.warn("[avo] ****************************************************");
  InternalAvoLogger.warn("[avo] WARNING Avo cannot be initialized in noop mode in production:");
  InternalAvoLogger.warn("[avo] - Overwriting configuration with noop=false.");
  InternalAvoLogger.warn("[avo] - Please reach out if you want to be able to run Avo in production mode with noop=true");
  InternalAvoLogger.warn("[avo] ****************************************************");
  __AVO_NOOP__ = false;
}
if (__AVO_NOOP__) {
  InternalAvoLogger.log("[avo] ****************************************************");
  InternalAvoLogger.log("[avo] Avo is now initialized in noop mode. This means:");
  InternalAvoLogger.log("[avo] - No events will be sent");
  InternalAvoLogger.log("[avo] - No network requests are made");
  InternalAvoLogger.log("[avo] ****************************************************");
}
if (options.strict !== undefined) {
  __STRICT__ = options.strict !== false;
}
if (options.reportFailureAs !== undefined) {
  __REPORT_FAILURE_AS__ = options.reportFailureAs;
}
__WEB_DEBUGGER__ = !__AVO_NOOP__ && ((typeof window !== 'undefined' && (window as any).location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV__ !== AvoEnv.Prod));
if (!__AVO_NOOP__ && options.inspector !== undefined) {
  __INSPECTOR__ = options.inspector;
} else if (__AVO_ENV__ !== 'prod') {
  InternalAvoLogger.warn("[avo] Avo Inspector not provided in initAvo() call");
}

destinationOptions = destinationOptions || {};

if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions?.position) {
      _avo_debugger_send_position(options.webDebuggerOptions.position)
    }

(function() {
  if (typeof (window as any) === 'undefined') { return; }
  let init = function() {
    let iframe: any = document.createElement("iframe");
    document.body.appendChild(iframe);
    iframe.id = "avo-debugger";
    iframe.src = "https://www.avo.app/_debugger";
    iframe.style = "display: none;";
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
  
}
if (!__AVO_NOOP__) {
  if (__AVO_ENV__ === AvoEnv.Prod) {
}
if (__AVO_ENV__ === AvoEnv.Dev) {
}

Segment = SegmentDestination;
if (__AVO_ENV__ === 'prod') {
  Segment && Segment.make && Segment.make(__AVO_ENV__, null);
} else if (__AVO_ENV__ === 'dev') {
  Segment && Segment.make && Segment.make(__AVO_ENV__, null);
} else {
  console[__REPORT_FAILURE_AS__ || 'error']("[avo] No staging key is set for Segment. Head to destination settings in Avo to set a staging key.");
  Segment && Segment.make && Segment.make(__AVO_ENV__, null);
}
if (__AVO_ENV__ === AvoEnv.Dev) {
  // debug console in Avo
  _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
}
}
}

export function setAvoLogger(avoLogger: AvoLogger | null) {
__AVO_LOGGER__ = avoLogger;
}

export interface ProductAddedProperties {
  brand: string;
  cartId: number;
  category: string;
  color: string;
  condition: string;
  currency: string;
  daysOnSale: number;
  discountTier: number | null | undefined;
  lastCall: number;
  material: string;
  name: string;
  price: number;
  productDiscount: number;
  productDiscountAmount: number;
  productFavorited: number;
  productId: number;
  quantity: number;
  queryId: string | null | undefined;
  searchIndex: string;
  url: string;
  value: number;
  brands: string[] | null | undefined;
  categories: string[];
  productSubcategory: string[];
  style: string | null | undefined;
  sku: string | null | undefined;
}
/**
 * Product Added: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.brand: no description
 * @param properties.cartId: no description
 * @param properties.category: no description
 * @param properties.color: no description
 * @param properties.condition: no description
 * @param properties.currency: no description
 * @param properties.daysOnSale: no description
 * @param properties.discountTier: no description
 * @param properties.lastCall: no description
 * @param properties.material: no description
 * @param properties.name: no description
 * @param properties.price: no description
 * @param properties.productDiscount: no description
 * @param properties.productDiscountAmount: no description
 * @param properties.productFavorited: no description
 * @param properties.productId: no description
 * @param properties.quantity: no description
 * @param properties.queryId: no description
 * @param properties.searchIndex: no description
 * @param properties.url: no description
 * @param properties.value: no description
 * @param properties.brands: no description
 * @param properties.categories: no description
 * @param properties.productSubcategory: no description
 * @param properties.style: no description
 * @param properties.sku: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/86OPYZ5mA}
 */
export function productAdded(properties: ProductAddedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "f7eejdMs_i", name: "brand", value: properties.brand});
eventPropertiesArray.push({id: "gbspX3tuqm", name: "cart_id", value: properties.cartId});
eventPropertiesArray.push({id: "roD5Ric9UH", name: "category", value: properties.category});
eventPropertiesArray.push({id: "piIj_RkUTH", name: "color", value: properties.color});
eventPropertiesArray.push({id: "sS4t7EnkrT", name: "condition", value: properties.condition});
eventPropertiesArray.push({id: "64gwOuqGWN", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "jX0hh8gbrv", name: "days_on_sale", value: properties.daysOnSale});
properties.discountTier !== undefined && properties.discountTier !== null ?
  eventPropertiesArray.push({id: "Hb6u9sv0CR", name: "discount_tier", value: properties.discountTier}) :
  eventPropertiesArray.push({id: "Hb6u9sv0CR", name: "discount_tier", value: null});
eventPropertiesArray.push({id: "ZjeUyiXvWG", name: "last_call", value: properties.lastCall});
eventPropertiesArray.push({id: "Vv5I6Iu0xr", name: "material", value: properties.material});
eventPropertiesArray.push({id: "hQyT0pPUgC", name: "name", value: properties.name});
eventPropertiesArray.push({id: "R6VJy4rRDD", name: "price", value: properties.price});
eventPropertiesArray.push({id: "JQQd6CaNsc", name: "product_discount", value: properties.productDiscount});
eventPropertiesArray.push({id: "PlAHQSCK1Nf", name: "product_discount_amount", value: properties.productDiscountAmount});
eventPropertiesArray.push({id: "ulRZEFmRPQr", name: "product_favorited", value: properties.productFavorited});
eventPropertiesArray.push({id: "v_NXlFwJHWe", name: "product_id", value: properties.productId});
eventPropertiesArray.push({id: "K8EZemDH8eZ", name: "quantity", value: properties.quantity});
properties.queryId !== undefined && properties.queryId !== null ?
  eventPropertiesArray.push({id: "bluwNrIWJuw", name: "query_id", value: properties.queryId}) :
  eventPropertiesArray.push({id: "bluwNrIWJuw", name: "query_id", value: null});
eventPropertiesArray.push({id: "43DAyHOmx3s", name: "search_index", value: properties.searchIndex});
eventPropertiesArray.push({id: "qG5_CagbN7d", name: "url", value: properties.url});
eventPropertiesArray.push({id: "0sokEHGrjFk", name: "value", value: properties.value});
properties.brands !== undefined && properties.brands !== null ?
  eventPropertiesArray.push({id: "ntzP51W2Ts9UHMy3qRJJz", name: "brands", value: properties.brands}) :
  eventPropertiesArray.push({id: "ntzP51W2Ts9UHMy3qRJJz", name: "brands", value: null});
eventPropertiesArray.push({id: "Lz9j92HOlDHCwOCpi4czI", name: "categories", value: properties.categories});
eventPropertiesArray.push({id: "SLBfzc35WGnJ3dabup_UW", name: "product_subcategory", value: properties.productSubcategory});
properties.style !== undefined && properties.style !== null ?
  eventPropertiesArray.push({id: "PQ45LXJvHUTQfgEBatStA", name: "style", value: properties.style}) :
  eventPropertiesArray.push({id: "PQ45LXJvHUTQfgEBatStA", name: "style", value: null});
properties.sku !== undefined && properties.sku !== null ?
  eventPropertiesArray.push({id: "Lp56lMaJ9nV6XWHg-HKY8", name: "sku", value: properties.sku}) :
  eventPropertiesArray.push({id: "Lp56lMaJ9nV6XWHg-HKY8", name: "sku", value: null});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "86OPYZ5mA", "70d3643df1b297760664070ef37d28d565c4be39018242b7c5075badd253321b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Product Added", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("86OPYZ5mA", "Product Added", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Added", eventProperties, "86OPYZ5mA", "70d3643df1b297760664070ef37d28d565c4be39018242b7c5075badd253321b");
}
// destination Segment
Segment.logEvent("Product Added", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ProductViewedProperties {
  brand: string;
  category: string;
  color: string;
  condition: string;
  currency: string;
  daysOnSale: number;
  discountTier: number;
  isSoldOut: number;
  lastCall: number;
  material: string;
  name: string;
  price: number;
  productDiscount: number;
  productDiscountAmount: number;
  productFavorited: number;
  productId: number;
  productRecommended: number;
  quantity: number;
  url: string;
  value: number;
  categories: string[] | null | undefined;
  productSubcategory: string[];
  sku: string | null | undefined;
  style: string | null | undefined;
  brands: string[] | null | undefined;
  queryId: string | null | undefined;
  searchIndex: string | null | undefined;
}
/**
 * Product Viewed: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.brand: no description
 * @param properties.category: no description
 * @param properties.color: no description
 * @param properties.condition: no description
 * @param properties.currency: no description
 * @param properties.daysOnSale: no description
 * @param properties.discountTier: no description
 * @param properties.isSoldOut: no description
 * @param properties.lastCall: no description
 * @param properties.material: no description
 * @param properties.name: no description
 * @param properties.price: no description
 * @param properties.productDiscount: no description
 * @param properties.productDiscountAmount: no description
 * @param properties.productFavorited: no description
 * @param properties.productId: no description
 * @param properties.productRecommended: no description
 * @param properties.quantity: no description
 * @param properties.url: no description
 * @param properties.value: no description
 * @param properties.categories: no description
 * @param properties.productSubcategory: no description
 * @param properties.sku: no description
 * @param properties.style: no description
 * @param properties.brands: no description
 * @param properties.queryId: no description
 * @param properties.searchIndex: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/yhHo-1Xl-y}
 */
export function productViewed(properties: ProductViewedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "f7eejdMs_i", name: "brand", value: properties.brand});
eventPropertiesArray.push({id: "roD5Ric9UH", name: "category", value: properties.category});
eventPropertiesArray.push({id: "piIj_RkUTH", name: "color", value: properties.color});
eventPropertiesArray.push({id: "sS4t7EnkrT", name: "condition", value: properties.condition});
eventPropertiesArray.push({id: "64gwOuqGWN", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "jX0hh8gbrv", name: "days_on_sale", value: properties.daysOnSale});
eventPropertiesArray.push({id: "Hb6u9sv0CR", name: "discount_tier", value: properties.discountTier});
eventPropertiesArray.push({id: "YdpeNKm6Ff6", name: "is_sold_out", value: properties.isSoldOut});
eventPropertiesArray.push({id: "ZjeUyiXvWG", name: "last_call", value: properties.lastCall});
eventPropertiesArray.push({id: "Vv5I6Iu0xr", name: "material", value: properties.material});
eventPropertiesArray.push({id: "hQyT0pPUgC", name: "name", value: properties.name});
eventPropertiesArray.push({id: "R6VJy4rRDD", name: "price", value: properties.price});
eventPropertiesArray.push({id: "JQQd6CaNsc", name: "product_discount", value: properties.productDiscount});
eventPropertiesArray.push({id: "PlAHQSCK1Nf", name: "product_discount_amount", value: properties.productDiscountAmount});
eventPropertiesArray.push({id: "ulRZEFmRPQr", name: "product_favorited", value: properties.productFavorited});
eventPropertiesArray.push({id: "v_NXlFwJHWe", name: "product_id", value: properties.productId});
eventPropertiesArray.push({id: "74Jx3SFJ89j", name: "product_recommended", value: properties.productRecommended});
eventPropertiesArray.push({id: "K8EZemDH8eZ", name: "quantity", value: properties.quantity});
eventPropertiesArray.push({id: "qG5_CagbN7d", name: "url", value: properties.url});
eventPropertiesArray.push({id: "0sokEHGrjFk", name: "value", value: properties.value});
properties.categories !== undefined && properties.categories !== null ?
  eventPropertiesArray.push({id: "Lz9j92HOlDHCwOCpi4czI", name: "categories", value: properties.categories}) :
  eventPropertiesArray.push({id: "Lz9j92HOlDHCwOCpi4czI", name: "categories", value: null});
eventPropertiesArray.push({id: "SLBfzc35WGnJ3dabup_UW", name: "product_subcategory", value: properties.productSubcategory});
properties.sku !== undefined && properties.sku !== null ?
  eventPropertiesArray.push({id: "Lp56lMaJ9nV6XWHg-HKY8", name: "sku", value: properties.sku}) :
  eventPropertiesArray.push({id: "Lp56lMaJ9nV6XWHg-HKY8", name: "sku", value: null});
properties.style !== undefined && properties.style !== null ?
  eventPropertiesArray.push({id: "PQ45LXJvHUTQfgEBatStA", name: "style", value: properties.style}) :
  eventPropertiesArray.push({id: "PQ45LXJvHUTQfgEBatStA", name: "style", value: null});
properties.brands !== undefined && properties.brands !== null ?
  eventPropertiesArray.push({id: "ntzP51W2Ts9UHMy3qRJJz", name: "brands", value: properties.brands}) :
  eventPropertiesArray.push({id: "ntzP51W2Ts9UHMy3qRJJz", name: "brands", value: null});
properties.queryId !== undefined && properties.queryId !== null ?
  eventPropertiesArray.push({id: "bluwNrIWJuw", name: "query_id", value: properties.queryId}) :
  eventPropertiesArray.push({id: "bluwNrIWJuw", name: "query_id", value: null});
properties.searchIndex !== undefined && properties.searchIndex !== null ?
  eventPropertiesArray.push({id: "43DAyHOmx3s", name: "search_index", value: properties.searchIndex}) :
  eventPropertiesArray.push({id: "43DAyHOmx3s", name: "search_index", value: null});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "yhHo-1Xl-y", "374b8eb6dd63d5e472fe2d692f81a5504eb6e08fc916187589a2911c8c79bdee", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Product Viewed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("yhHo-1Xl-y", "Product Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Viewed", eventProperties, "yhHo-1Xl-y", "374b8eb6dd63d5e472fe2d692f81a5504eb6e08fc916187589a2911c8c79bdee");
}
// destination Segment
Segment.logEvent("Product Viewed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ProductListFilteredProperties {
  listId: string;
  filters: Filters[];
  category: string;
  sorts: Sorts[];
  listType: string | null | undefined;
  listValue: string | null | undefined;
}
/**
 * Product List Filtered: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.listId: no description
 * @param properties.filters: no description
 * @param properties.category: no description
 * @param properties.sorts: no description
 * @param properties.listType: no description
 * @param properties.listValue: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/9c6u2JSfDl}
 */
export function productListFiltered(properties: ProductListFilteredProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "UIUbQKdJ3g", name: "list_id", value: properties.listId});
eventPropertiesArray.push({id: "p16PlScMd", name: "filters", value: properties.filters});
eventPropertiesArray.push({id: "roD5Ric9UH", name: "category", value: properties.category});
eventPropertiesArray.push({id: "0e30HGLV1FS", name: "sorts", value: properties.sorts});
properties.listType !== undefined && properties.listType !== null ?
  eventPropertiesArray.push({id: "6GE9JdShXvbtnUqjAh5rQ", name: "list_type", value: properties.listType}) :
  eventPropertiesArray.push({id: "6GE9JdShXvbtnUqjAh5rQ", name: "list_type", value: null});
properties.listValue !== undefined && properties.listValue !== null ?
  eventPropertiesArray.push({id: "tApa9gsToMHmbN72xfJ9D", name: "list_value", value: properties.listValue}) :
  eventPropertiesArray.push({id: "tApa9gsToMHmbN72xfJ9D", name: "list_value", value: null});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "9c6u2JSfDl", "742317ac982416bc533b61cca30e9606b6fb446fdda075091350353fdb59e0f5", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Product List Filtered", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("9c6u2JSfDl", "Product List Filtered", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product List Filtered", eventProperties, "9c6u2JSfDl", "742317ac982416bc533b61cca30e9606b6fb446fdda075091350353fdb59e0f5");
}
// destination Segment
Segment.logEvent("Product List Filtered", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface PageViewedProperties {
  customDestinationPageName_: string;
  hasRecommendation: number | null | undefined;
  languageCode: string;
  name: string | null | undefined;
  siteSection: string;
  userId: number;
}
/**
 * Page Viewed: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.hasRecommendation: no description
 * @param properties.languageCode: no description
 * @param properties.name: no description
 * @param properties.siteSection: no description
 * @param properties.userId: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/M3HJNMfGIB5dDQDl_9QCS}
 */
export function pageViewed(properties: PageViewedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
properties.hasRecommendation !== undefined && properties.hasRecommendation !== null ?
  eventPropertiesArray.push({id: "d721xjmbtUpOHMZaCXz87", name: "has_recommendation", value: properties.hasRecommendation}) :
  eventPropertiesArray.push({id: "d721xjmbtUpOHMZaCXz87", name: "has_recommendation", value: null});
eventPropertiesArray.push({id: "DiXXDQByEA3deVFLI_9HS", name: "language_code", value: properties.languageCode});
properties.name !== undefined && properties.name !== null ?
  eventPropertiesArray.push({id: "hQyT0pPUgC", name: "name", value: properties.name}) :
  eventPropertiesArray.push({id: "hQyT0pPUgC", name: "name", value: null});
eventPropertiesArray.push({id: "yEqMSNB8DLvtd2tvFxqSU", name: "site_section", value: properties.siteSection});
eventPropertiesArray.push({id: "JpCobU1f4zuMpSY2AS_ph", name: "user_id", value: properties.userId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "M3HJNMfGIB5dDQDl_9QCS", "9249a70efca0dc369fd7bef7fbc950db8c1daee984969df0bb6e67a3e970101d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Page Viewed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("M3HJNMfGIB5dDQDl_9QCS", "Page Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  // destination Segment
  if (Segment.logPage) {
    Segment.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
} else {
  InternalAvoLogger.error('Page method is not implemented in the destination', '');
}
} else {
  // do nothing
}
}

export interface ProductSearchedProperties {
  query: string;
  searchType: string;
}
/**
 * Product Searched: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.query: no description
 * @param properties.searchType: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/S16xbtD_s4-M4bgfqfV6i}
 */
export function productSearched(properties: ProductSearchedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jZQ1_CXm3e__uFTq1Wn9n", name: "query", value: properties.query});
eventPropertiesArray.push({id: "SjAUpmQMelRiepZtSqcMA", name: "search_type", value: properties.searchType});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "S16xbtD_s4-M4bgfqfV6i", "7579a7c8b81b88107930e1b35bbb7cae82d11965e2f232a66d05aa8cf7a07d6d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Product Searched", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("S16xbtD_s4-M4bgfqfV6i", "Product Searched", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Searched", eventProperties, "S16xbtD_s4-M4bgfqfV6i", "7579a7c8b81b88107930e1b35bbb7cae82d11965e2f232a66d05aa8cf7a07d6d");
}
// destination Segment
Segment.logEvent("Product Searched", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ProductListViewedProperties {
  category: string;
  products: Products[];
  listId: string;
}
/**
 * Product List Viewed: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.category: no description
 * @param properties.products: no description
 * @param properties.listId: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/O34Bm-fmzb3JV6kSNEtAL}
 */
export function productListViewed(properties: ProductListViewedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "roD5Ric9UH", name: "category", value: properties.category});
eventPropertiesArray.push({id: "XI1RwV7Iy1", name: "products", value: properties.products});
eventPropertiesArray.push({id: "UIUbQKdJ3g", name: "list_id", value: properties.listId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "O34Bm-fmzb3JV6kSNEtAL", "02e54209f8ff46f2118393ea43805a9cdd9f3c201534b41736ac483dd1117811", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Product List Viewed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("O34Bm-fmzb3JV6kSNEtAL", "Product List Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product List Viewed", eventProperties, "O34Bm-fmzb3JV6kSNEtAL", "02e54209f8ff46f2118393ea43805a9cdd9f3c201534b41736ac483dd1117811");
}
// destination Segment
Segment.logEvent("Product List Viewed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface CartViewedProperties {
  cartId: number;
  discount: number;
  discountAmount: number;
  products: Products[];
  totalQuantity: number;
}
/**
 * Cart Viewed: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.cartId: no description
 * @param properties.discount: no description
 * @param properties.discountAmount: no description
 * @param properties.products: no description
 * @param properties.totalQuantity: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/ZpEckabPOK7zpaqirngqW}
 */
export function cartViewed(properties: CartViewedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "gbspX3tuqm", name: "cart_id", value: properties.cartId});
eventPropertiesArray.push({id: "4Fr_SNSnCK_", name: "discount", value: properties.discount});
eventPropertiesArray.push({id: "z2snF_JpLpD", name: "discount_amount", value: properties.discountAmount});
eventPropertiesArray.push({id: "XI1RwV7Iy1", name: "products", value: properties.products});
eventPropertiesArray.push({id: "jRucDRmmdUL", name: "total_quantity", value: properties.totalQuantity});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "ZpEckabPOK7zpaqirngqW", "a81d19333a8b2fabe3b9d4061921f15cdd93c99fe77303e796259b3a418c8963", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Cart Viewed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("ZpEckabPOK7zpaqirngqW", "Cart Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Cart Viewed", eventProperties, "ZpEckabPOK7zpaqirngqW", "a81d19333a8b2fabe3b9d4061921f15cdd93c99fe77303e796259b3a418c8963");
}
// destination Segment
Segment.logEvent("Cart Viewed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface CheckoutStartedProperties {
  cartId: number;
  discount: number;
  discountAmount: number;
  products: Products[];
  revenue: number;
  step: number;
  stepName: string;
}
/**
 * Checkout Started: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.cartId: no description
 * @param properties.discount: no description
 * @param properties.discountAmount: no description
 * @param properties.products: no description
 * @param properties.revenue: no description
 * @param properties.step: no description
 * @param properties.stepName: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/5ixmqDjoGSg4ekO0ZiFqz}
 */
export function checkoutStarted(properties: CheckoutStartedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "gbspX3tuqm", name: "cart_id", value: properties.cartId});
eventPropertiesArray.push({id: "4Fr_SNSnCK_", name: "discount", value: properties.discount});
eventPropertiesArray.push({id: "z2snF_JpLpD", name: "discount_amount", value: properties.discountAmount});
eventPropertiesArray.push({id: "XI1RwV7Iy1", name: "products", value: properties.products});
eventPropertiesArray.push({id: "ySUyksu9uFU", name: "revenue", value: properties.revenue});
eventPropertiesArray.push({id: "_fR6EKkqVc", name: "step", value: properties.step});
eventPropertiesArray.push({id: "HimiI16DlO", name: "step_name", value: properties.stepName});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "5ixmqDjoGSg4ekO0ZiFqz", "46ad2e0014e576dacda7405839ccd523e4b6327c77fd55ee50d6953155bbf7db", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Checkout Started", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("5ixmqDjoGSg4ekO0ZiFqz", "Checkout Started", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Checkout Started", eventProperties, "5ixmqDjoGSg4ekO0ZiFqz", "46ad2e0014e576dacda7405839ccd523e4b6327c77fd55ee50d6953155bbf7db");
}
// destination Segment
Segment.logEvent("Checkout Started", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface CheckoutStepViewedProperties {
  step: number;
  stepName: string;
  shippingMethod: string;
  paymentMethod: string;
}
/**
 * Checkout Step Viewed: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.step: no description
 * @param properties.stepName: no description
 * @param properties.shippingMethod: no description
 * @param properties.paymentMethod: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/aTWmPkpTAOccVue3Jt2Lx}
 */
export function checkoutStepViewed(properties: CheckoutStepViewedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "_fR6EKkqVc", name: "step", value: properties.step});
eventPropertiesArray.push({id: "HimiI16DlO", name: "step_name", value: properties.stepName});
eventPropertiesArray.push({id: "QIKrlmw1Gm", name: "shipping_method", value: properties.shippingMethod});
eventPropertiesArray.push({id: "8EQ3RN0Slm", name: "payment_method", value: properties.paymentMethod});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "aTWmPkpTAOccVue3Jt2Lx", "4b8b9c0b3aee8ad2bd4412afdbf89e2a61b711a77788b01f972d90efa3ca6b07", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Checkout Step Viewed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("aTWmPkpTAOccVue3Jt2Lx", "Checkout Step Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Checkout Step Viewed", eventProperties, "aTWmPkpTAOccVue3Jt2Lx", "4b8b9c0b3aee8ad2bd4412afdbf89e2a61b711a77788b01f972d90efa3ca6b07");
}
// destination Segment
Segment.logEvent("Checkout Step Viewed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface CheckoutStepCompletedProperties {
  '3DS': number;
  step: number;
  stepName: string;
  stepValue: string;
  shippingMethod: string;
  paymentMethod: string;
}
/**
 * Checkout Step Completed: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.3DS: no description
 * @param properties.step: no description
 * @param properties.stepName: no description
 * @param properties.stepValue: no description
 * @param properties.shippingMethod: no description
 * @param properties.paymentMethod: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/7UNAdaKjB2KM6IiHh_dtU}
 */
export function checkoutStepCompleted(properties: CheckoutStepCompletedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "HGXDDmqvikQ", name: "3DS", value: properties['3DS']});
eventPropertiesArray.push({id: "_fR6EKkqVc", name: "step", value: properties.step});
eventPropertiesArray.push({id: "HimiI16DlO", name: "step_name", value: properties.stepName});
eventPropertiesArray.push({id: "HayEII5I3Dh", name: "step_value", value: properties.stepValue});
eventPropertiesArray.push({id: "QIKrlmw1Gm", name: "shipping_method", value: properties.shippingMethod});
eventPropertiesArray.push({id: "8EQ3RN0Slm", name: "payment_method", value: properties.paymentMethod});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "7UNAdaKjB2KM6IiHh_dtU", "73f6dd7dd73a1ff9c5c88a1d645bf85101ebccd4f68063c7946d9441dbffe40d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Checkout Step Completed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("7UNAdaKjB2KM6IiHh_dtU", "Checkout Step Completed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Checkout Step Completed", eventProperties, "7UNAdaKjB2KM6IiHh_dtU", "73f6dd7dd73a1ff9c5c88a1d645bf85101ebccd4f68063c7946d9441dbffe40d");
}
// destination Segment
Segment.logEvent("Checkout Step Completed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface PaymentInfoEnteredProperties {
  paymentMethod: string;
  step: number;
  stepName: string;
  stepValue: string;
}
/**
 * Payment Info Entered: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.paymentMethod: no description
 * @param properties.step: no description
 * @param properties.stepName: no description
 * @param properties.stepValue: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/NWkSlNheETGwCY4r3RWAd}
 */
export function paymentInfoEntered(properties: PaymentInfoEnteredProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "8EQ3RN0Slm", name: "payment_method", value: properties.paymentMethod});
eventPropertiesArray.push({id: "_fR6EKkqVc", name: "step", value: properties.step});
eventPropertiesArray.push({id: "HimiI16DlO", name: "step_name", value: properties.stepName});
eventPropertiesArray.push({id: "HayEII5I3Dh", name: "step_value", value: properties.stepValue});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "NWkSlNheETGwCY4r3RWAd", "0ada355f38899e617bd8c4ada1e545be5540c1fd276776016c5c91a40590ae74", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Payment Info Entered", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("NWkSlNheETGwCY4r3RWAd", "Payment Info Entered", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Payment Info Entered", eventProperties, "NWkSlNheETGwCY4r3RWAd", "0ada355f38899e617bd8c4ada1e545be5540c1fd276776016c5c91a40590ae74");
}
// destination Segment
Segment.logEvent("Payment Info Entered", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ProductRemovedProperties {
  brand: string;
  cartId: number;
  category: string;
  condition: string;
  currency: string;
  daysOnSale: number;
  discountTier: number;
  isSoldOut: number;
  lastCall: number;
  name: string;
  price: number;
  productDiscount: number;
  productDiscountAmount: number;
  productFavorited: number;
  productId: number;
  quantity: number;
  url: string;
  value: number;
  color: string;
  material: string;
  brands: string[] | null | undefined;
  categories: string[] | null | undefined;
  productSubcategory: string[];
  sku: string | null | undefined;
  style: string | null | undefined;
}
/**
 * Product Removed: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.brand: no description
 * @param properties.cartId: no description
 * @param properties.category: no description
 * @param properties.condition: no description
 * @param properties.currency: no description
 * @param properties.daysOnSale: no description
 * @param properties.discountTier: no description
 * @param properties.isSoldOut: no description
 * @param properties.lastCall: no description
 * @param properties.name: no description
 * @param properties.price: no description
 * @param properties.productDiscount: no description
 * @param properties.productDiscountAmount: no description
 * @param properties.productFavorited: no description
 * @param properties.productId: no description
 * @param properties.quantity: no description
 * @param properties.url: no description
 * @param properties.value: no description
 * @param properties.color: no description
 * @param properties.material: no description
 * @param properties.brands: no description
 * @param properties.categories: no description
 * @param properties.productSubcategory: no description
 * @param properties.sku: no description
 * @param properties.style: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/67_kKzZzX3LXoXknRuQUk}
 */
export function productRemoved(properties: ProductRemovedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "f7eejdMs_i", name: "brand", value: properties.brand});
eventPropertiesArray.push({id: "gbspX3tuqm", name: "cart_id", value: properties.cartId});
eventPropertiesArray.push({id: "roD5Ric9UH", name: "category", value: properties.category});
eventPropertiesArray.push({id: "sS4t7EnkrT", name: "condition", value: properties.condition});
eventPropertiesArray.push({id: "64gwOuqGWN", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "jX0hh8gbrv", name: "days_on_sale", value: properties.daysOnSale});
eventPropertiesArray.push({id: "Hb6u9sv0CR", name: "discount_tier", value: properties.discountTier});
eventPropertiesArray.push({id: "YdpeNKm6Ff6", name: "is_sold_out", value: properties.isSoldOut});
eventPropertiesArray.push({id: "ZjeUyiXvWG", name: "last_call", value: properties.lastCall});
eventPropertiesArray.push({id: "hQyT0pPUgC", name: "name", value: properties.name});
eventPropertiesArray.push({id: "R6VJy4rRDD", name: "price", value: properties.price});
eventPropertiesArray.push({id: "JQQd6CaNsc", name: "product_discount", value: properties.productDiscount});
eventPropertiesArray.push({id: "PlAHQSCK1Nf", name: "product_discount_amount", value: properties.productDiscountAmount});
eventPropertiesArray.push({id: "ulRZEFmRPQr", name: "product_favorited", value: properties.productFavorited});
eventPropertiesArray.push({id: "v_NXlFwJHWe", name: "product_id", value: properties.productId});
eventPropertiesArray.push({id: "K8EZemDH8eZ", name: "quantity", value: properties.quantity});
eventPropertiesArray.push({id: "qG5_CagbN7d", name: "url", value: properties.url});
eventPropertiesArray.push({id: "0sokEHGrjFk", name: "value", value: properties.value});
eventPropertiesArray.push({id: "piIj_RkUTH", name: "color", value: properties.color});
eventPropertiesArray.push({id: "Vv5I6Iu0xr", name: "material", value: properties.material});
properties.brands !== undefined && properties.brands !== null ?
  eventPropertiesArray.push({id: "ntzP51W2Ts9UHMy3qRJJz", name: "brands", value: properties.brands}) :
  eventPropertiesArray.push({id: "ntzP51W2Ts9UHMy3qRJJz", name: "brands", value: null});
properties.categories !== undefined && properties.categories !== null ?
  eventPropertiesArray.push({id: "Lz9j92HOlDHCwOCpi4czI", name: "categories", value: properties.categories}) :
  eventPropertiesArray.push({id: "Lz9j92HOlDHCwOCpi4czI", name: "categories", value: null});
eventPropertiesArray.push({id: "SLBfzc35WGnJ3dabup_UW", name: "product_subcategory", value: properties.productSubcategory});
properties.sku !== undefined && properties.sku !== null ?
  eventPropertiesArray.push({id: "Lp56lMaJ9nV6XWHg-HKY8", name: "sku", value: properties.sku}) :
  eventPropertiesArray.push({id: "Lp56lMaJ9nV6XWHg-HKY8", name: "sku", value: null});
properties.style !== undefined && properties.style !== null ?
  eventPropertiesArray.push({id: "PQ45LXJvHUTQfgEBatStA", name: "style", value: properties.style}) :
  eventPropertiesArray.push({id: "PQ45LXJvHUTQfgEBatStA", name: "style", value: null});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "67_kKzZzX3LXoXknRuQUk", "da7e241a99b8521c30db0515f069a64c2c7c5506544a9ea16780c2c3341c418b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Product Removed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("67_kKzZzX3LXoXknRuQUk", "Product Removed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Removed", eventProperties, "67_kKzZzX3LXoXknRuQUk", "da7e241a99b8521c30db0515f069a64c2c7c5506544a9ea16780c2c3341c418b");
}
// destination Segment
Segment.logEvent("Product Removed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface OrderPlacedProperties {
  '3DS': number;
  coupon: string | null | undefined;
  couponAmount: number;
  currency: string;
  discount: number;
  discountAmount: number;
  giftCardPercentage: number;
  layaway: number;
  orderId: number;
  orderValue: number;
  paymentMethod: string;
  pointOfSale: string;
  products: Products[];
  revenue: number;
  shipping: number;
  shippingMethod: string;
  storeCreditPercentage: number;
  subtotal: number;
  tax: number;
  total: number;
  totalQuantity: number;
}
/**
 * Order Placed: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.3DS: no description
 * @param properties.coupon: no description
 * @param properties.couponAmount: no description
 * @param properties.currency: no description
 * @param properties.discount: no description
 * @param properties.discountAmount: no description
 * @param properties.giftCardPercentage: no description
 * @param properties.layaway: no description
 * @param properties.orderId: no description
 * @param properties.orderValue: no description
 * @param properties.paymentMethod: no description
 * @param properties.pointOfSale: no description
 * @param properties.products: no description
 * @param properties.revenue: no description
 * @param properties.shipping: no description
 * @param properties.shippingMethod: no description
 * @param properties.storeCreditPercentage: no description
 * @param properties.subtotal: no description
 * @param properties.tax: no description
 * @param properties.total: no description
 * @param properties.totalQuantity: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/vRU2HpXK7LMI-KddlDzBc}
 */
export function orderPlaced(properties: OrderPlacedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "HGXDDmqvikQ", name: "3DS", value: properties['3DS']});
properties.coupon !== undefined && properties.coupon !== null ?
  eventPropertiesArray.push({id: "F6vmiePHvVbYX44YgPqwK", name: "coupon", value: properties.coupon}) :
  eventPropertiesArray.push({id: "F6vmiePHvVbYX44YgPqwK", name: "coupon", value: null});
eventPropertiesArray.push({id: "i8xP91s1BZ3", name: "coupon_amount", value: properties.couponAmount});
eventPropertiesArray.push({id: "64gwOuqGWN", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "4Fr_SNSnCK_", name: "discount", value: properties.discount});
eventPropertiesArray.push({id: "z2snF_JpLpD", name: "discount_amount", value: properties.discountAmount});
eventPropertiesArray.push({id: "FB5v6bI4wDq", name: "gift_card_percentage", value: properties.giftCardPercentage});
eventPropertiesArray.push({id: "oVhy8U5grYY", name: "layaway", value: properties.layaway});
eventPropertiesArray.push({id: "22JFEyAW_7H", name: "order_id", value: properties.orderId});
eventPropertiesArray.push({id: "iTELFpEpUoW", name: "order_value", value: properties.orderValue});
eventPropertiesArray.push({id: "8EQ3RN0Slm", name: "payment_method", value: properties.paymentMethod});
eventPropertiesArray.push({id: "j04S_Qm-l1c", name: "point_of_sale", value: properties.pointOfSale});
eventPropertiesArray.push({id: "XI1RwV7Iy1", name: "products", value: properties.products});
eventPropertiesArray.push({id: "ySUyksu9uFU", name: "revenue", value: properties.revenue});
eventPropertiesArray.push({id: "7_KYBW5AA77", name: "shipping", value: properties.shipping});
eventPropertiesArray.push({id: "QIKrlmw1Gm", name: "shipping_method", value: properties.shippingMethod});
eventPropertiesArray.push({id: "HwT6rSibaW7", name: "store_credit_percentage", value: properties.storeCreditPercentage});
eventPropertiesArray.push({id: "DDAinGollHv", name: "subtotal", value: properties.subtotal});
eventPropertiesArray.push({id: "0Qo764SA1tz", name: "tax", value: properties.tax});
eventPropertiesArray.push({id: "sUo1_Mdug6w", name: "total", value: properties.total});
eventPropertiesArray.push({id: "jRucDRmmdUL", name: "total_quantity", value: properties.totalQuantity});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "vRU2HpXK7LMI-KddlDzBc", "290f6894277dc10ab6dbf1083a019aa2bf002549d6543887ef1eba09e510e284", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Order Placed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("vRU2HpXK7LMI-KddlDzBc", "Order Placed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Order Placed", eventProperties, "vRU2HpXK7LMI-KddlDzBc", "290f6894277dc10ab6dbf1083a019aa2bf002549d6543887ef1eba09e510e284");
}
// destination Segment
Segment.logEvent("Order Placed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface OrderCompletedProperties {
  '3DS': number;
  coupon: string | null | undefined;
  couponAmount: number;
  currency: string;
  discount: number;
  discountAmount: number;
  giftCardPercentage: number;
  layaway: number;
  orderId: number;
  orderValue: number;
  paymentMethod: string;
  pointOfSale: string;
  products: Products[];
  revenue: number;
  shipping: number;
  shippingMethod: string;
  storeCreditPercentage: number;
  subtotal: number;
  tax: number;
  total: number;
  totalQuantity: number;
  guest: number | null | undefined;
  newCustomer: boolean | null | undefined;
  searchIndex: string | null | undefined;
}
/**
 * Order Completed: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.3DS: no description
 * @param properties.coupon: no description
 * @param properties.couponAmount: no description
 * @param properties.currency: no description
 * @param properties.discount: no description
 * @param properties.discountAmount: no description
 * @param properties.giftCardPercentage: no description
 * @param properties.layaway: no description
 * @param properties.orderId: no description
 * @param properties.orderValue: no description
 * @param properties.paymentMethod: no description
 * @param properties.pointOfSale: no description
 * @param properties.products: no description
 * @param properties.revenue: no description
 * @param properties.shipping: no description
 * @param properties.shippingMethod: no description
 * @param properties.storeCreditPercentage: no description
 * @param properties.subtotal: no description
 * @param properties.tax: no description
 * @param properties.total: no description
 * @param properties.totalQuantity: no description
 * @param properties.guest: no description
 * @param properties.newCustomer: no description
 * @param properties.searchIndex: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/3UIQVUUqOGPN-zgfMg62n}
 */
export function orderCompleted(properties: OrderCompletedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "HGXDDmqvikQ", name: "3DS", value: properties['3DS']});
properties.coupon !== undefined && properties.coupon !== null ?
  eventPropertiesArray.push({id: "F6vmiePHvVbYX44YgPqwK", name: "coupon", value: properties.coupon}) :
  eventPropertiesArray.push({id: "F6vmiePHvVbYX44YgPqwK", name: "coupon", value: null});
eventPropertiesArray.push({id: "i8xP91s1BZ3", name: "coupon_amount", value: properties.couponAmount});
eventPropertiesArray.push({id: "64gwOuqGWN", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "4Fr_SNSnCK_", name: "discount", value: properties.discount});
eventPropertiesArray.push({id: "z2snF_JpLpD", name: "discount_amount", value: properties.discountAmount});
eventPropertiesArray.push({id: "FB5v6bI4wDq", name: "gift_card_percentage", value: properties.giftCardPercentage});
eventPropertiesArray.push({id: "oVhy8U5grYY", name: "layaway", value: properties.layaway});
eventPropertiesArray.push({id: "22JFEyAW_7H", name: "order_id", value: properties.orderId});
eventPropertiesArray.push({id: "iTELFpEpUoW", name: "order_value", value: properties.orderValue});
eventPropertiesArray.push({id: "8EQ3RN0Slm", name: "payment_method", value: properties.paymentMethod});
eventPropertiesArray.push({id: "j04S_Qm-l1c", name: "point_of_sale", value: properties.pointOfSale});
eventPropertiesArray.push({id: "XI1RwV7Iy1", name: "products", value: properties.products});
eventPropertiesArray.push({id: "ySUyksu9uFU", name: "revenue", value: properties.revenue});
eventPropertiesArray.push({id: "7_KYBW5AA77", name: "shipping", value: properties.shipping});
eventPropertiesArray.push({id: "QIKrlmw1Gm", name: "shipping_method", value: properties.shippingMethod});
eventPropertiesArray.push({id: "HwT6rSibaW7", name: "store_credit_percentage", value: properties.storeCreditPercentage});
eventPropertiesArray.push({id: "DDAinGollHv", name: "subtotal", value: properties.subtotal});
eventPropertiesArray.push({id: "0Qo764SA1tz", name: "tax", value: properties.tax});
eventPropertiesArray.push({id: "sUo1_Mdug6w", name: "total", value: properties.total});
eventPropertiesArray.push({id: "jRucDRmmdUL", name: "total_quantity", value: properties.totalQuantity});
properties.guest !== undefined && properties.guest !== null ?
  eventPropertiesArray.push({id: "kMPbya_t7Q9", name: "guest", value: properties.guest}) :
  eventPropertiesArray.push({id: "kMPbya_t7Q9", name: "guest", value: null});
properties.newCustomer !== undefined && properties.newCustomer !== null ?
  eventPropertiesArray.push({id: "xAw7B07r_oRB6hOfN8GA2", name: "new_customer", value: properties.newCustomer}) :
  eventPropertiesArray.push({id: "xAw7B07r_oRB6hOfN8GA2", name: "new_customer", value: null});
properties.searchIndex !== undefined && properties.searchIndex !== null ?
  eventPropertiesArray.push({id: "43DAyHOmx3s", name: "search_index", value: properties.searchIndex}) :
  eventPropertiesArray.push({id: "43DAyHOmx3s", name: "search_index", value: null});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "3UIQVUUqOGPN-zgfMg62n", "7d086b381003b7315ca3b99197cf1d2622765192944d9b68fbc6b04809f1accb", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Order Completed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("3UIQVUUqOGPN-zgfMg62n", "Order Completed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Order Completed", eventProperties, "3UIQVUUqOGPN-zgfMg62n", "7d086b381003b7315ca3b99197cf1d2622765192944d9b68fbc6b04809f1accb");
}
// destination Segment
Segment.logEvent("Order Completed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface LayawayInstallmentProperties {
  '3DS': number;
  coupon: string | null | undefined;
  couponAmount: number;
  currency: string;
  discount: number;
  discountAmount: number;
  giftCardPercentage: number;
  orderId: number;
  orderValue: number;
  paymentMethod: string;
  pointOfSale: string;
  products: Products[];
  revenue: number;
  shipping: number;
  shippingMethod: string;
  storeCreditPercentage: number;
  subtotal: number;
  tax: number;
  total: number;
  totalQuantity: number;
  layawayInitialPayment: number;
  layawayInstallmentNumber: number;
  layawayPaymentValue: number;
}
/**
 * Layaway Installment: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.3DS: no description
 * @param properties.coupon: no description
 * @param properties.couponAmount: no description
 * @param properties.currency: no description
 * @param properties.discount: no description
 * @param properties.discountAmount: no description
 * @param properties.giftCardPercentage: no description
 * @param properties.orderId: no description
 * @param properties.orderValue: no description
 * @param properties.paymentMethod: no description
 * @param properties.pointOfSale: no description
 * @param properties.products: no description
 * @param properties.revenue: no description
 * @param properties.shipping: no description
 * @param properties.shippingMethod: no description
 * @param properties.storeCreditPercentage: no description
 * @param properties.subtotal: no description
 * @param properties.tax: no description
 * @param properties.total: no description
 * @param properties.totalQuantity: no description
 * @param properties.layawayInitialPayment: no description
 * @param properties.layawayInstallmentNumber: no description
 * @param properties.layawayPaymentValue: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/ieeHi5teiXVXlrn_eE3_I}
 */
export function layawayInstallment(properties: LayawayInstallmentProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "HGXDDmqvikQ", name: "3DS", value: properties['3DS']});
properties.coupon !== undefined && properties.coupon !== null ?
  eventPropertiesArray.push({id: "F6vmiePHvVbYX44YgPqwK", name: "coupon", value: properties.coupon}) :
  eventPropertiesArray.push({id: "F6vmiePHvVbYX44YgPqwK", name: "coupon", value: null});
eventPropertiesArray.push({id: "i8xP91s1BZ3", name: "coupon_amount", value: properties.couponAmount});
eventPropertiesArray.push({id: "64gwOuqGWN", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "4Fr_SNSnCK_", name: "discount", value: properties.discount});
eventPropertiesArray.push({id: "z2snF_JpLpD", name: "discount_amount", value: properties.discountAmount});
eventPropertiesArray.push({id: "FB5v6bI4wDq", name: "gift_card_percentage", value: properties.giftCardPercentage});
eventPropertiesArray.push({id: "22JFEyAW_7H", name: "order_id", value: properties.orderId});
eventPropertiesArray.push({id: "iTELFpEpUoW", name: "order_value", value: properties.orderValue});
eventPropertiesArray.push({id: "8EQ3RN0Slm", name: "payment_method", value: properties.paymentMethod});
eventPropertiesArray.push({id: "j04S_Qm-l1c", name: "point_of_sale", value: properties.pointOfSale});
eventPropertiesArray.push({id: "XI1RwV7Iy1", name: "products", value: properties.products});
eventPropertiesArray.push({id: "ySUyksu9uFU", name: "revenue", value: properties.revenue});
eventPropertiesArray.push({id: "7_KYBW5AA77", name: "shipping", value: properties.shipping});
eventPropertiesArray.push({id: "QIKrlmw1Gm", name: "shipping_method", value: properties.shippingMethod});
eventPropertiesArray.push({id: "HwT6rSibaW7", name: "store_credit_percentage", value: properties.storeCreditPercentage});
eventPropertiesArray.push({id: "DDAinGollHv", name: "subtotal", value: properties.subtotal});
eventPropertiesArray.push({id: "0Qo764SA1tz", name: "tax", value: properties.tax});
eventPropertiesArray.push({id: "sUo1_Mdug6w", name: "total", value: properties.total});
eventPropertiesArray.push({id: "jRucDRmmdUL", name: "total_quantity", value: properties.totalQuantity});
eventPropertiesArray.push({id: "26fp5I2syewSXXbYl-2S5", name: "layaway_initial_payment", value: properties.layawayInitialPayment});
eventPropertiesArray.push({id: "V06ZmxFYevRE6jIiUcUof", name: "layaway_installment_number", value: properties.layawayInstallmentNumber});
eventPropertiesArray.push({id: "JIEse4qFkWEoMNy1JdVNU", name: "layaway_payment_value", value: properties.layawayPaymentValue});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "ieeHi5teiXVXlrn_eE3_I", "c6c0254fb13c5c0ba5dbdefd6524ba2372c583bfc573e9140868b8118e5adc37", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Layaway Installment", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("ieeHi5teiXVXlrn_eE3_I", "Layaway Installment", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Layaway Installment", eventProperties, "ieeHi5teiXVXlrn_eE3_I", "c6c0254fb13c5c0ba5dbdefd6524ba2372c583bfc573e9140868b8118e5adc37");
}
// destination Segment
Segment.logEvent("Layaway Installment", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ExperimentViewedProperties {
  experimentName: string;
  variationName: string;
}
/**
 * Experiment Viewed: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.experimentName: no description
 * @param properties.variationName: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/d2Q8TyAkREvsAB6EWNAqP}
 */
export function experimentViewed(properties: ExperimentViewedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "w3wKIC-Ff1A_wHcByYrji", name: "experiment_name", value: properties.experimentName});
eventPropertiesArray.push({id: "SGUenzdtGsm6chBgMDuVO", name: "variation_name", value: properties.variationName});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "d2Q8TyAkREvsAB6EWNAqP", "807e50bf652ee091929e12074e48009a6df8843f54daaf90002828028219c84f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Experiment Viewed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("d2Q8TyAkREvsAB6EWNAqP", "Experiment Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Experiment Viewed", eventProperties, "d2Q8TyAkREvsAB6EWNAqP", "807e50bf652ee091929e12074e48009a6df8843f54daaf90002828028219c84f");
}
// destination Segment
Segment.logEvent("Experiment Viewed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ProductClickedProperties {
  brand: string;
  category: string;
  color: string;
  condition: string;
  currency: string;
  daysOnSale: number;
  discountTier: number;
  lastCall: number;
  material: string;
  name: string;
  price: number;
  productDiscount: number;
  productDiscountAmount: number;
  productFavorited: number;
  productId: number;
  productRecommended: number;
  quantity: number;
  url: string;
  value: number;
  categories: string[] | null | undefined;
  productSubcategory: string[];
  sku: string | null | undefined;
  style: string | null | undefined;
  brands: string[] | null | undefined;
  queryId: string | null | undefined;
  searchIndex: string | null | undefined;
  listCategory: string;
  listId: string;
  position: number;
}
/**
 * Product Clicked: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.brand: no description
 * @param properties.category: no description
 * @param properties.color: no description
 * @param properties.condition: no description
 * @param properties.currency: no description
 * @param properties.daysOnSale: no description
 * @param properties.discountTier: no description
 * @param properties.lastCall: no description
 * @param properties.material: no description
 * @param properties.name: no description
 * @param properties.price: no description
 * @param properties.productDiscount: no description
 * @param properties.productDiscountAmount: no description
 * @param properties.productFavorited: no description
 * @param properties.productId: no description
 * @param properties.productRecommended: no description
 * @param properties.quantity: no description
 * @param properties.url: no description
 * @param properties.value: no description
 * @param properties.categories: no description
 * @param properties.productSubcategory: no description
 * @param properties.sku: no description
 * @param properties.style: no description
 * @param properties.brands: no description
 * @param properties.queryId: no description
 * @param properties.searchIndex: no description
 * @param properties.listCategory: no description
 * @param properties.listId: no description
 * @param properties.position: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/E7ECBvyCRLdOB-xSi72j2}
 */
export function productClicked(properties: ProductClickedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "f7eejdMs_i", name: "brand", value: properties.brand});
eventPropertiesArray.push({id: "roD5Ric9UH", name: "category", value: properties.category});
eventPropertiesArray.push({id: "piIj_RkUTH", name: "color", value: properties.color});
eventPropertiesArray.push({id: "sS4t7EnkrT", name: "condition", value: properties.condition});
eventPropertiesArray.push({id: "64gwOuqGWN", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "jX0hh8gbrv", name: "days_on_sale", value: properties.daysOnSale});
eventPropertiesArray.push({id: "Hb6u9sv0CR", name: "discount_tier", value: properties.discountTier});
eventPropertiesArray.push({id: "ZjeUyiXvWG", name: "last_call", value: properties.lastCall});
eventPropertiesArray.push({id: "Vv5I6Iu0xr", name: "material", value: properties.material});
eventPropertiesArray.push({id: "hQyT0pPUgC", name: "name", value: properties.name});
eventPropertiesArray.push({id: "R6VJy4rRDD", name: "price", value: properties.price});
eventPropertiesArray.push({id: "JQQd6CaNsc", name: "product_discount", value: properties.productDiscount});
eventPropertiesArray.push({id: "PlAHQSCK1Nf", name: "product_discount_amount", value: properties.productDiscountAmount});
eventPropertiesArray.push({id: "ulRZEFmRPQr", name: "product_favorited", value: properties.productFavorited});
eventPropertiesArray.push({id: "v_NXlFwJHWe", name: "product_id", value: properties.productId});
eventPropertiesArray.push({id: "74Jx3SFJ89j", name: "product_recommended", value: properties.productRecommended});
eventPropertiesArray.push({id: "K8EZemDH8eZ", name: "quantity", value: properties.quantity});
eventPropertiesArray.push({id: "qG5_CagbN7d", name: "url", value: properties.url});
eventPropertiesArray.push({id: "0sokEHGrjFk", name: "value", value: properties.value});
properties.categories !== undefined && properties.categories !== null ?
  eventPropertiesArray.push({id: "Lz9j92HOlDHCwOCpi4czI", name: "categories", value: properties.categories}) :
  eventPropertiesArray.push({id: "Lz9j92HOlDHCwOCpi4czI", name: "categories", value: null});
eventPropertiesArray.push({id: "SLBfzc35WGnJ3dabup_UW", name: "product_subcategory", value: properties.productSubcategory});
properties.sku !== undefined && properties.sku !== null ?
  eventPropertiesArray.push({id: "Lp56lMaJ9nV6XWHg-HKY8", name: "sku", value: properties.sku}) :
  eventPropertiesArray.push({id: "Lp56lMaJ9nV6XWHg-HKY8", name: "sku", value: null});
properties.style !== undefined && properties.style !== null ?
  eventPropertiesArray.push({id: "PQ45LXJvHUTQfgEBatStA", name: "style", value: properties.style}) :
  eventPropertiesArray.push({id: "PQ45LXJvHUTQfgEBatStA", name: "style", value: null});
properties.brands !== undefined && properties.brands !== null ?
  eventPropertiesArray.push({id: "ntzP51W2Ts9UHMy3qRJJz", name: "brands", value: properties.brands}) :
  eventPropertiesArray.push({id: "ntzP51W2Ts9UHMy3qRJJz", name: "brands", value: null});
properties.queryId !== undefined && properties.queryId !== null ?
  eventPropertiesArray.push({id: "bluwNrIWJuw", name: "query_id", value: properties.queryId}) :
  eventPropertiesArray.push({id: "bluwNrIWJuw", name: "query_id", value: null});
properties.searchIndex !== undefined && properties.searchIndex !== null ?
  eventPropertiesArray.push({id: "43DAyHOmx3s", name: "search_index", value: properties.searchIndex}) :
  eventPropertiesArray.push({id: "43DAyHOmx3s", name: "search_index", value: null});
eventPropertiesArray.push({id: "XL8TbJRgtf", name: "list_category", value: properties.listCategory});
eventPropertiesArray.push({id: "UIUbQKdJ3g", name: "list_id", value: properties.listId});
eventPropertiesArray.push({id: "wdAM1qZZwL", name: "position", value: properties.position});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "E7ECBvyCRLdOB-xSi72j2", "c5911f05ba64f098d270b05d0d845f74780cda2557433c5b969c4bae19b71103", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Product Clicked", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("E7ECBvyCRLdOB-xSi72j2", "Product Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Clicked", eventProperties, "E7ECBvyCRLdOB-xSi72j2", "c5911f05ba64f098d270b05d0d845f74780cda2557433c5b969c4bae19b71103");
}
// destination Segment
Segment.logEvent("Product Clicked", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ModalOpenedProperties {
  type: string;
  url: string;
}
/**
 * Modal Opened: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.type: no description
 * @param properties.url: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/PBoz_6imAxJvmSa2E2-gD}
 */
export function modalOpened(properties: ModalOpenedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "ULfaMx3nUjzq6f5MJ-ZO3", name: "type", value: properties.type});
eventPropertiesArray.push({id: "qG5_CagbN7d", name: "url", value: properties.url});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "PBoz_6imAxJvmSa2E2-gD", "2cc1a0fcb11a5ead22ae1eaa1a40c27b32b0ba91217f25532710969b6e47a526", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Modal Opened", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("PBoz_6imAxJvmSa2E2-gD", "Modal Opened", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Modal Opened", eventProperties, "PBoz_6imAxJvmSa2E2-gD", "2cc1a0fcb11a5ead22ae1eaa1a40c27b32b0ba91217f25532710969b6e47a526");
}
// destination Segment
Segment.logEvent("Modal Opened", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ModalClosedProperties {
  type: string;
  url: string;
}
/**
 * Modal Closed: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.type: no description
 * @param properties.url: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/ocuMUautTjqIkSQftxQbC}
 */
export function modalClosed(properties: ModalClosedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "ULfaMx3nUjzq6f5MJ-ZO3", name: "type", value: properties.type});
eventPropertiesArray.push({id: "qG5_CagbN7d", name: "url", value: properties.url});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "ocuMUautTjqIkSQftxQbC", "7dac7c16dc12ca4c26cde834babf25bf88fa6295986b64f694828a5e7a0d2d74", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Modal Closed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("ocuMUautTjqIkSQftxQbC", "Modal Closed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Modal Closed", eventProperties, "ocuMUautTjqIkSQftxQbC", "7dac7c16dc12ca4c26cde834babf25bf88fa6295986b64f694828a5e7a0d2d74");
}
// destination Segment
Segment.logEvent("Modal Closed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface PromoClickedProperties {
  creative: string;
  name: string;
  promotionId: number;
  position: number;
}
/**
 * Promo Clicked: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.creative: no description
 * @param properties.name: no description
 * @param properties.promotionId: no description
 * @param properties.position: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/zaB8_Jp-UynGN8gLaa1az}
 */
export function promoClicked(properties: PromoClickedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "OPqn3A-bT", name: "creative", value: properties.creative});
eventPropertiesArray.push({id: "hQyT0pPUgC", name: "name", value: properties.name});
eventPropertiesArray.push({id: "dzvxPiuvnR_hXVJMHz31O", name: "promotion_id", value: properties.promotionId});
eventPropertiesArray.push({id: "wdAM1qZZwL", name: "position", value: properties.position});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "zaB8_Jp-UynGN8gLaa1az", "af9cb3966a5f5507c1e4f6f2d1205e19f896dabafec30f22c4e17ee7fa460c0e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Promo Clicked", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("zaB8_Jp-UynGN8gLaa1az", "Promo Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Promo Clicked", eventProperties, "zaB8_Jp-UynGN8gLaa1az", "af9cb3966a5f5507c1e4f6f2d1205e19f896dabafec30f22c4e17ee7fa460c0e");
}
// destination Segment
Segment.logEvent("Promo Clicked", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface PromoViewedProperties {
  creative: string;
  name: string;
  promotionId: number;
  position: number;
}
/**
 * Promo Viewed: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.creative: no description
 * @param properties.name: no description
 * @param properties.promotionId: no description
 * @param properties.position: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/Ml_1uhUCes5BQvDmnSt4k}
 */
export function promoViewed(properties: PromoViewedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "OPqn3A-bT", name: "creative", value: properties.creative});
eventPropertiesArray.push({id: "hQyT0pPUgC", name: "name", value: properties.name});
eventPropertiesArray.push({id: "dzvxPiuvnR_hXVJMHz31O", name: "promotion_id", value: properties.promotionId});
eventPropertiesArray.push({id: "wdAM1qZZwL", name: "position", value: properties.position});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "Ml_1uhUCes5BQvDmnSt4k", "14832386ceda6934b9a6ae79be6b2af65cfc798d0ed83131a6edde205c5ec4f5", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Promo Viewed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("Ml_1uhUCes5BQvDmnSt4k", "Promo Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Promo Viewed", eventProperties, "Ml_1uhUCes5BQvDmnSt4k", "14832386ceda6934b9a6ae79be6b2af65cfc798d0ed83131a6edde205c5ec4f5");
}
// destination Segment
Segment.logEvent("Promo Viewed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ProductAddedToWishlistProperties {
  brand: string;
  category: string;
  color: string;
  condition: string;
  currency: string;
  daysOnSale: number;
  discountTier: number;
  lastCall: number;
  material: string;
  name: string;
  price: number;
  productDiscount: number;
  productDiscountAmount: number;
  productId: number;
  productRecommended: number | null | undefined;
  quantity: number;
  url: string;
  value: number;
  categories: string[];
  productSubcategory: string[];
  brands: string[] | null | undefined;
  sku: string | null | undefined;
  style: string | null | undefined;
}
/**
 * Product Added to Wishlist: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.brand: no description
 * @param properties.category: no description
 * @param properties.color: no description
 * @param properties.condition: no description
 * @param properties.currency: no description
 * @param properties.daysOnSale: no description
 * @param properties.discountTier: no description
 * @param properties.lastCall: no description
 * @param properties.material: no description
 * @param properties.name: no description
 * @param properties.price: no description
 * @param properties.productDiscount: no description
 * @param properties.productDiscountAmount: no description
 * @param properties.productId: no description
 * @param properties.productRecommended: no description
 * @param properties.quantity: no description
 * @param properties.url: no description
 * @param properties.value: no description
 * @param properties.categories: no description
 * @param properties.productSubcategory: no description
 * @param properties.brands: no description
 * @param properties.sku: no description
 * @param properties.style: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/igqyjag3Kz56ImwBmhmEL}
 */
export function productAddedToWishlist(properties: ProductAddedToWishlistProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "f7eejdMs_i", name: "brand", value: properties.brand});
eventPropertiesArray.push({id: "roD5Ric9UH", name: "category", value: properties.category});
eventPropertiesArray.push({id: "piIj_RkUTH", name: "color", value: properties.color});
eventPropertiesArray.push({id: "sS4t7EnkrT", name: "condition", value: properties.condition});
eventPropertiesArray.push({id: "64gwOuqGWN", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "jX0hh8gbrv", name: "days_on_sale", value: properties.daysOnSale});
eventPropertiesArray.push({id: "Hb6u9sv0CR", name: "discount_tier", value: properties.discountTier});
eventPropertiesArray.push({id: "ZjeUyiXvWG", name: "last_call", value: properties.lastCall});
eventPropertiesArray.push({id: "Vv5I6Iu0xr", name: "material", value: properties.material});
eventPropertiesArray.push({id: "hQyT0pPUgC", name: "name", value: properties.name});
eventPropertiesArray.push({id: "R6VJy4rRDD", name: "price", value: properties.price});
eventPropertiesArray.push({id: "JQQd6CaNsc", name: "product_discount", value: properties.productDiscount});
eventPropertiesArray.push({id: "PlAHQSCK1Nf", name: "product_discount_amount", value: properties.productDiscountAmount});
eventPropertiesArray.push({id: "v_NXlFwJHWe", name: "product_id", value: properties.productId});
properties.productRecommended !== undefined && properties.productRecommended !== null ?
  eventPropertiesArray.push({id: "74Jx3SFJ89j", name: "product_recommended", value: properties.productRecommended}) :
  eventPropertiesArray.push({id: "74Jx3SFJ89j", name: "product_recommended", value: null});
eventPropertiesArray.push({id: "K8EZemDH8eZ", name: "quantity", value: properties.quantity});
eventPropertiesArray.push({id: "qG5_CagbN7d", name: "url", value: properties.url});
eventPropertiesArray.push({id: "0sokEHGrjFk", name: "value", value: properties.value});
eventPropertiesArray.push({id: "Lz9j92HOlDHCwOCpi4czI", name: "categories", value: properties.categories});
eventPropertiesArray.push({id: "SLBfzc35WGnJ3dabup_UW", name: "product_subcategory", value: properties.productSubcategory});
properties.brands !== undefined && properties.brands !== null ?
  eventPropertiesArray.push({id: "ntzP51W2Ts9UHMy3qRJJz", name: "brands", value: properties.brands}) :
  eventPropertiesArray.push({id: "ntzP51W2Ts9UHMy3qRJJz", name: "brands", value: null});
properties.sku !== undefined && properties.sku !== null ?
  eventPropertiesArray.push({id: "Lp56lMaJ9nV6XWHg-HKY8", name: "sku", value: properties.sku}) :
  eventPropertiesArray.push({id: "Lp56lMaJ9nV6XWHg-HKY8", name: "sku", value: null});
properties.style !== undefined && properties.style !== null ?
  eventPropertiesArray.push({id: "PQ45LXJvHUTQfgEBatStA", name: "style", value: properties.style}) :
  eventPropertiesArray.push({id: "PQ45LXJvHUTQfgEBatStA", name: "style", value: null});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "igqyjag3Kz56ImwBmhmEL", "901c9112d4cde9c5eaf9529e06665870d92f76c9c6c6dc7af2898d6afb2adebf", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Product Added to Wishlist", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("igqyjag3Kz56ImwBmhmEL", "Product Added to Wishlist", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Added to Wishlist", eventProperties, "igqyjag3Kz56ImwBmhmEL", "901c9112d4cde9c5eaf9529e06665870d92f76c9c6c6dc7af2898d6afb2adebf");
}
// destination Segment
Segment.logEvent("Product Added to Wishlist", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface DetailClickProperties {
  brand: string;
  category: string;
  color: string;
  condition: string;
  currency: string;
  daysOnSale: number;
  discountTier: number;
  lastCall: number;
  material: string;
  name: string;
  price: number;
  productDiscount: number;
  productDiscountAmount: number;
  productId: number;
  quantity: number;
  url: string;
  value: number;
  categories: string[];
  productSubcategory: string[];
  sku: string | null | undefined;
  style: string | null | undefined;
  brands: string[] | null | undefined;
  tabClick: number | null | undefined;
  tabClickType: string | null | undefined;
}
/**
 * Detail Click: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.brand: no description
 * @param properties.category: no description
 * @param properties.color: no description
 * @param properties.condition: no description
 * @param properties.currency: no description
 * @param properties.daysOnSale: no description
 * @param properties.discountTier: no description
 * @param properties.lastCall: no description
 * @param properties.material: no description
 * @param properties.name: no description
 * @param properties.price: no description
 * @param properties.productDiscount: no description
 * @param properties.productDiscountAmount: no description
 * @param properties.productId: no description
 * @param properties.quantity: no description
 * @param properties.url: no description
 * @param properties.value: no description
 * @param properties.categories: no description
 * @param properties.productSubcategory: no description
 * @param properties.sku: no description
 * @param properties.style: no description
 * @param properties.brands: no description
 * @param properties.tabClick: no description
 * @param properties.tabClickType: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/m_eOPDj7cq4er5f3dq3F-}
 */
export function detailClick(properties: DetailClickProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "f7eejdMs_i", name: "brand", value: properties.brand});
eventPropertiesArray.push({id: "roD5Ric9UH", name: "category", value: properties.category});
eventPropertiesArray.push({id: "piIj_RkUTH", name: "color", value: properties.color});
eventPropertiesArray.push({id: "sS4t7EnkrT", name: "condition", value: properties.condition});
eventPropertiesArray.push({id: "64gwOuqGWN", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "jX0hh8gbrv", name: "days_on_sale", value: properties.daysOnSale});
eventPropertiesArray.push({id: "Hb6u9sv0CR", name: "discount_tier", value: properties.discountTier});
eventPropertiesArray.push({id: "ZjeUyiXvWG", name: "last_call", value: properties.lastCall});
eventPropertiesArray.push({id: "Vv5I6Iu0xr", name: "material", value: properties.material});
eventPropertiesArray.push({id: "hQyT0pPUgC", name: "name", value: properties.name});
eventPropertiesArray.push({id: "R6VJy4rRDD", name: "price", value: properties.price});
eventPropertiesArray.push({id: "JQQd6CaNsc", name: "product_discount", value: properties.productDiscount});
eventPropertiesArray.push({id: "PlAHQSCK1Nf", name: "product_discount_amount", value: properties.productDiscountAmount});
eventPropertiesArray.push({id: "v_NXlFwJHWe", name: "product_id", value: properties.productId});
eventPropertiesArray.push({id: "K8EZemDH8eZ", name: "quantity", value: properties.quantity});
eventPropertiesArray.push({id: "qG5_CagbN7d", name: "url", value: properties.url});
eventPropertiesArray.push({id: "0sokEHGrjFk", name: "value", value: properties.value});
eventPropertiesArray.push({id: "Lz9j92HOlDHCwOCpi4czI", name: "categories", value: properties.categories});
eventPropertiesArray.push({id: "SLBfzc35WGnJ3dabup_UW", name: "product_subcategory", value: properties.productSubcategory});
properties.sku !== undefined && properties.sku !== null ?
  eventPropertiesArray.push({id: "Lp56lMaJ9nV6XWHg-HKY8", name: "sku", value: properties.sku}) :
  eventPropertiesArray.push({id: "Lp56lMaJ9nV6XWHg-HKY8", name: "sku", value: null});
properties.style !== undefined && properties.style !== null ?
  eventPropertiesArray.push({id: "PQ45LXJvHUTQfgEBatStA", name: "style", value: properties.style}) :
  eventPropertiesArray.push({id: "PQ45LXJvHUTQfgEBatStA", name: "style", value: null});
properties.brands !== undefined && properties.brands !== null ?
  eventPropertiesArray.push({id: "ntzP51W2Ts9UHMy3qRJJz", name: "brands", value: properties.brands}) :
  eventPropertiesArray.push({id: "ntzP51W2Ts9UHMy3qRJJz", name: "brands", value: null});
properties.tabClick !== undefined && properties.tabClick !== null ?
  eventPropertiesArray.push({id: "uZLlhzBeeAzrLwBZHw7iZ", name: "tab_click", value: properties.tabClick}) :
  eventPropertiesArray.push({id: "uZLlhzBeeAzrLwBZHw7iZ", name: "tab_click", value: null});
properties.tabClickType !== undefined && properties.tabClickType !== null ?
  eventPropertiesArray.push({id: "kAbIw6A1I0E_xGYhzLbnQ", name: "tab_click_type", value: properties.tabClickType}) :
  eventPropertiesArray.push({id: "kAbIw6A1I0E_xGYhzLbnQ", name: "tab_click_type", value: null});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "m_eOPDj7cq4er5f3dq3F-", "de7ff24fb71cc70a0d44319865be1aa9679b3fa97112debf166e80ddb861dafe", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Detail Click", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("m_eOPDj7cq4er5f3dq3F-", "Detail Click", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Detail Click", eventProperties, "m_eOPDj7cq4er5f3dq3F-", "de7ff24fb71cc70a0d44319865be1aa9679b3fa97112debf166e80ddb861dafe");
}
// destination Segment
Segment.logEvent("Detail Click", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface QuoteFormStartedProperties {
  sellFormType: string;
  step: number;
  stepName: string;
  userId: number;
}
/**
 * Quote Form Started: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.sellFormType: no description
 * @param properties.step: no description
 * @param properties.stepName: no description
 * @param properties.userId: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/GEdN7ID-Vrv6OMLtxID5E}
 */
export function quoteFormStarted(properties: QuoteFormStartedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "yerB1JBTrWdu5My3Bf_PT", name: "sell_form_type", value: properties.sellFormType});
eventPropertiesArray.push({id: "_fR6EKkqVc", name: "step", value: properties.step});
eventPropertiesArray.push({id: "HimiI16DlO", name: "step_name", value: properties.stepName});
eventPropertiesArray.push({id: "JpCobU1f4zuMpSY2AS_ph", name: "user_id", value: properties.userId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "GEdN7ID-Vrv6OMLtxID5E", "18edd7601c5749b67a3867995f7f230fc50ca0ec64ca147b9ed5c72c2c7e0641", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Quote Form Started", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("GEdN7ID-Vrv6OMLtxID5E", "Quote Form Started", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Quote Form Started", eventProperties, "GEdN7ID-Vrv6OMLtxID5E", "18edd7601c5749b67a3867995f7f230fc50ca0ec64ca147b9ed5c72c2c7e0641");
}
// destination Segment
Segment.logEvent("Quote Form Started", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface QuoteFormStepCompletedProperties {
  brandId: number;
  sellFormType: string;
  step: number;
  stepName: string;
  stepValue: string;
  userId: number;
  categoryId: number;
}
/**
 * Quote Form Step Completed: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.brandId: no description
 * @param properties.sellFormType: no description
 * @param properties.step: no description
 * @param properties.stepName: no description
 * @param properties.stepValue: no description
 * @param properties.userId: no description
 * @param properties.categoryId: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/6HSzbilX7YX9zdKSolA84}
 */
export function quoteFormStepCompleted(properties: QuoteFormStepCompletedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "HrRQF_ILgobhR8SRRcBe9", name: "brand_id", value: properties.brandId});
eventPropertiesArray.push({id: "yerB1JBTrWdu5My3Bf_PT", name: "sell_form_type", value: properties.sellFormType});
eventPropertiesArray.push({id: "_fR6EKkqVc", name: "step", value: properties.step});
eventPropertiesArray.push({id: "HimiI16DlO", name: "step_name", value: properties.stepName});
eventPropertiesArray.push({id: "HayEII5I3Dh", name: "step_value", value: properties.stepValue});
eventPropertiesArray.push({id: "JpCobU1f4zuMpSY2AS_ph", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "ya9UWuN__9b88RN-K8LbO", name: "category_id", value: properties.categoryId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "6HSzbilX7YX9zdKSolA84", "c321a335b36c51dcb9f9981b49f8d49e630ce099e6ab9d4377c5a7a4d0be47e3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Quote Form Step Completed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("6HSzbilX7YX9zdKSolA84", "Quote Form Step Completed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Quote Form Step Completed", eventProperties, "6HSzbilX7YX9zdKSolA84", "c321a335b36c51dcb9f9981b49f8d49e630ce099e6ab9d4377c5a7a4d0be47e3");
}
// destination Segment
Segment.logEvent("Quote Form Step Completed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface QuoteFormCompletedProperties {
  email: string;
  pendingItemId: number;
  sellFormType: string;
  step: number;
  stepName: string;
  userId: number;
  quoteDraftId: number | null | undefined;
  quoteUuid: string;
}
/**
 * Quote Form Completed: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.email: no description
 * @param properties.pendingItemId: no description
 * @param properties.sellFormType: no description
 * @param properties.step: no description
 * @param properties.stepName: no description
 * @param properties.userId: no description
 * @param properties.quoteDraftId: no description
 * @param properties.quoteUuid: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/ZZUF7SPlF0G0Al-R1-Kxd}
 */
export function quoteFormCompleted(properties: QuoteFormCompletedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "J75xh81TCmpvqJw8xBjw7", name: "email", value: properties.email});
eventPropertiesArray.push({id: "tj3dFQ9IOrZNYYf0rWH_V", name: "pending_item_id", value: properties.pendingItemId});
eventPropertiesArray.push({id: "yerB1JBTrWdu5My3Bf_PT", name: "sell_form_type", value: properties.sellFormType});
eventPropertiesArray.push({id: "_fR6EKkqVc", name: "step", value: properties.step});
eventPropertiesArray.push({id: "HimiI16DlO", name: "step_name", value: properties.stepName});
eventPropertiesArray.push({id: "JpCobU1f4zuMpSY2AS_ph", name: "user_id", value: properties.userId});
properties.quoteDraftId !== undefined && properties.quoteDraftId !== null ?
  eventPropertiesArray.push({id: "PlgVwcCu9Vu260-W5Y51O", name: "quote_draft_id", value: properties.quoteDraftId}) :
  eventPropertiesArray.push({id: "PlgVwcCu9Vu260-W5Y51O", name: "quote_draft_id", value: null});
eventPropertiesArray.push({id: "83vC70QDwNphxblmDsz3n", name: "quote_uuid", value: properties.quoteUuid});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "ZZUF7SPlF0G0Al-R1-Kxd", "6bee5bd9bd98b45e52f737ef483c9b97d0c7645f2db2b46444323df8e954dc99", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Quote Form Completed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("ZZUF7SPlF0G0Al-R1-Kxd", "Quote Form Completed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Quote Form Completed", eventProperties, "ZZUF7SPlF0G0Al-R1-Kxd", "6bee5bd9bd98b45e52f737ef483c9b97d0c7645f2db2b46444323df8e954dc99");
}
// destination Segment
Segment.logEvent("Quote Form Completed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface QuoteFormSaveDraftProperties {
  quoteDraftId: number | null | undefined;
  userId: number;
}
/**
 * Quote Form Save Draft: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.quoteDraftId: no description
 * @param properties.userId: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/dqBjB4Ky7xdcwYFdAij8c}
 */
export function quoteFormSaveDraft(properties: QuoteFormSaveDraftProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
properties.quoteDraftId !== undefined && properties.quoteDraftId !== null ?
  eventPropertiesArray.push({id: "PlgVwcCu9Vu260-W5Y51O", name: "quote_draft_id", value: properties.quoteDraftId}) :
  eventPropertiesArray.push({id: "PlgVwcCu9Vu260-W5Y51O", name: "quote_draft_id", value: null});
eventPropertiesArray.push({id: "JpCobU1f4zuMpSY2AS_ph", name: "user_id", value: properties.userId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "dqBjB4Ky7xdcwYFdAij8c", "89faa19bd8fe5a929b886d0612aff9e37a1b326bf02b1850d88c916db83ea3c7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Quote Form Save Draft", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("dqBjB4Ky7xdcwYFdAij8c", "Quote Form Save Draft", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Quote Form Save Draft", eventProperties, "dqBjB4Ky7xdcwYFdAij8c", "89faa19bd8fe5a929b886d0612aff9e37a1b326bf02b1850d88c916db83ea3c7");
}
// destination Segment
Segment.logEvent("Quote Form Save Draft", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface AppointmentFormStartedProperties {
  sellFormType: string;
  step: number;
  stepName: string;
  userId: number;
}
/**
 * Appointment Form Started: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.sellFormType: no description
 * @param properties.step: no description
 * @param properties.stepName: no description
 * @param properties.userId: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/qNmE_4fay1P59xiqVB81r}
 */
export function appointmentFormStarted(properties: AppointmentFormStartedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "yerB1JBTrWdu5My3Bf_PT", name: "sell_form_type", value: properties.sellFormType});
eventPropertiesArray.push({id: "_fR6EKkqVc", name: "step", value: properties.step});
eventPropertiesArray.push({id: "HimiI16DlO", name: "step_name", value: properties.stepName});
eventPropertiesArray.push({id: "JpCobU1f4zuMpSY2AS_ph", name: "user_id", value: properties.userId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "qNmE_4fay1P59xiqVB81r", "acbfad11ba81eed2ce02b102f8c52e9b3cd92b31a457750da76480928d70f094", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Appointment Form Started", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("qNmE_4fay1P59xiqVB81r", "Appointment Form Started", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Appointment Form Started", eventProperties, "qNmE_4fay1P59xiqVB81r", "acbfad11ba81eed2ce02b102f8c52e9b3cd92b31a457750da76480928d70f094");
}
// destination Segment
Segment.logEvent("Appointment Form Started", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface AppointmentFormStepCompletedProperties {
  sellFormType: string;
  step: number;
  stepName: string;
  stepValue: string;
  userId: number;
}
/**
 * Appointment Form Step Completed: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.sellFormType: no description
 * @param properties.step: no description
 * @param properties.stepName: no description
 * @param properties.stepValue: no description
 * @param properties.userId: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/9YQpK8IlspBAfQYmHP0AG}
 */
export function appointmentFormStepCompleted(properties: AppointmentFormStepCompletedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "yerB1JBTrWdu5My3Bf_PT", name: "sell_form_type", value: properties.sellFormType});
eventPropertiesArray.push({id: "_fR6EKkqVc", name: "step", value: properties.step});
eventPropertiesArray.push({id: "HimiI16DlO", name: "step_name", value: properties.stepName});
eventPropertiesArray.push({id: "HayEII5I3Dh", name: "step_value", value: properties.stepValue});
eventPropertiesArray.push({id: "JpCobU1f4zuMpSY2AS_ph", name: "user_id", value: properties.userId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "9YQpK8IlspBAfQYmHP0AG", "d6b83705f61bef0cea0cabadf446315b847ba21ba1dbdb0e2ed94ba3bf6fc2e5", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Appointment Form Step Completed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("9YQpK8IlspBAfQYmHP0AG", "Appointment Form Step Completed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Appointment Form Step Completed", eventProperties, "9YQpK8IlspBAfQYmHP0AG", "d6b83705f61bef0cea0cabadf446315b847ba21ba1dbdb0e2ed94ba3bf6fc2e5");
}
// destination Segment
Segment.logEvent("Appointment Form Step Completed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface AppointmentFormCompletedProperties {
  appointmentId: number;
  email: string;
  sellFormType: string;
  step: number;
  stepName: string;
  userId: number;
}
/**
 * Appointment Form Completed: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.appointmentId: no description
 * @param properties.email: no description
 * @param properties.sellFormType: no description
 * @param properties.step: no description
 * @param properties.stepName: no description
 * @param properties.userId: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/yAk7aE5jwZqN8jSsB8Qqx}
 */
export function appointmentFormCompleted(properties: AppointmentFormCompletedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "8yTIdCrVXdmJFJoj_24LS", name: "appointment_id", value: properties.appointmentId});
eventPropertiesArray.push({id: "J75xh81TCmpvqJw8xBjw7", name: "email", value: properties.email});
eventPropertiesArray.push({id: "yerB1JBTrWdu5My3Bf_PT", name: "sell_form_type", value: properties.sellFormType});
eventPropertiesArray.push({id: "_fR6EKkqVc", name: "step", value: properties.step});
eventPropertiesArray.push({id: "HimiI16DlO", name: "step_name", value: properties.stepName});
eventPropertiesArray.push({id: "JpCobU1f4zuMpSY2AS_ph", name: "user_id", value: properties.userId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "yAk7aE5jwZqN8jSsB8Qqx", "aacbe14af463e99608c258611d65848c36b40b375a122b474bddcd8d9de9e232", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Appointment Form Completed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("yAk7aE5jwZqN8jSsB8Qqx", "Appointment Form Completed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Appointment Form Completed", eventProperties, "yAk7aE5jwZqN8jSsB8Qqx", "aacbe14af463e99608c258611d65848c36b40b375a122b474bddcd8d9de9e232");
}
// destination Segment
Segment.logEvent("Appointment Form Completed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface DocumentWritingProperties {
  brand: string;
}
/**
 * Document Writing: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.brand: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/LDwp3cl4D78Em7fXHkzKq}
 */
export function documentWriting(properties: DocumentWritingProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "f7eejdMs_i", name: "brand", value: properties.brand});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "LDwp3cl4D78Em7fXHkzKq", "503d61390a8c967368339af50e7d37a9a6b78015dac46c244fb8a98c32ed45bb", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Document Writing", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("LDwp3cl4D78Em7fXHkzKq", "Document Writing", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Document Writing", eventProperties, "LDwp3cl4D78Em7fXHkzKq", "503d61390a8c967368339af50e7d37a9a6b78015dac46c244fb8a98c32ed45bb");
}
// destination Segment
Segment.logEvent("Document Writing", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ProductRemovedFromWishlistProperties {
  brand: string;
  categories: string[];
  category: string;
  color: string;
  condition: string;
  currency: string;
  daysOnSale: number;
  discountTier: number;
  lastCall: number;
  material: string;
  name: string;
  price: number;
  productDiscount: number;
  productDiscountAmount: number;
  productId: number;
  productRecommended: number | null | undefined;
  productSubcategory: string[];
  quantity: number;
  url: string;
  value: number;
}
/**
 * Product Removed from Wishlist: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.brand: no description
 * @param properties.categories: no description
 * @param properties.category: no description
 * @param properties.color: no description
 * @param properties.condition: no description
 * @param properties.currency: no description
 * @param properties.daysOnSale: no description
 * @param properties.discountTier: no description
 * @param properties.lastCall: no description
 * @param properties.material: no description
 * @param properties.name: no description
 * @param properties.price: no description
 * @param properties.productDiscount: no description
 * @param properties.productDiscountAmount: no description
 * @param properties.productId: no description
 * @param properties.productRecommended: no description
 * @param properties.productSubcategory: no description
 * @param properties.quantity: no description
 * @param properties.url: no description
 * @param properties.value: no description
 * 
 * @see {@link https://www.avo.app/schemas/rnvgiYxmtEqBZwPzQZWl/events/ccu_63WuSI5HoNU-dg6RK}
 */
export function productRemovedFromWishlist(properties: ProductRemovedFromWishlistProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "f7eejdMs_i", name: "brand", value: properties.brand});
eventPropertiesArray.push({id: "Lz9j92HOlDHCwOCpi4czI", name: "categories", value: properties.categories});
eventPropertiesArray.push({id: "roD5Ric9UH", name: "category", value: properties.category});
eventPropertiesArray.push({id: "piIj_RkUTH", name: "color", value: properties.color});
eventPropertiesArray.push({id: "sS4t7EnkrT", name: "condition", value: properties.condition});
eventPropertiesArray.push({id: "64gwOuqGWN", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "jX0hh8gbrv", name: "days_on_sale", value: properties.daysOnSale});
eventPropertiesArray.push({id: "Hb6u9sv0CR", name: "discount_tier", value: properties.discountTier});
eventPropertiesArray.push({id: "ZjeUyiXvWG", name: "last_call", value: properties.lastCall});
eventPropertiesArray.push({id: "Vv5I6Iu0xr", name: "material", value: properties.material});
eventPropertiesArray.push({id: "hQyT0pPUgC", name: "name", value: properties.name});
eventPropertiesArray.push({id: "R6VJy4rRDD", name: "price", value: properties.price});
eventPropertiesArray.push({id: "JQQd6CaNsc", name: "product_discount", value: properties.productDiscount});
eventPropertiesArray.push({id: "PlAHQSCK1Nf", name: "product_discount_amount", value: properties.productDiscountAmount});
eventPropertiesArray.push({id: "v_NXlFwJHWe", name: "product_id", value: properties.productId});
properties.productRecommended !== undefined && properties.productRecommended !== null ?
  eventPropertiesArray.push({id: "74Jx3SFJ89j", name: "product_recommended", value: properties.productRecommended}) :
  eventPropertiesArray.push({id: "74Jx3SFJ89j", name: "product_recommended", value: null});
eventPropertiesArray.push({id: "SLBfzc35WGnJ3dabup_UW", name: "product_subcategory", value: properties.productSubcategory});
eventPropertiesArray.push({id: "K8EZemDH8eZ", name: "quantity", value: properties.quantity});
eventPropertiesArray.push({id: "qG5_CagbN7d", name: "url", value: properties.url});
eventPropertiesArray.push({id: "0sokEHGrjFk", name: "value", value: properties.value});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "ccu_63WuSI5HoNU-dg6RK", "41bf2c5faa0e34093d8605913b82e7c6e5e8b9b4f4f423dad8e9868c63862aa2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Product Removed from Wishlist", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("ccu_63WuSI5HoNU-dg6RK", "Product Removed from Wishlist", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Removed from Wishlist", eventProperties, "ccu_63WuSI5HoNU-dg6RK", "41bf2c5faa0e34093d8605913b82e7c6e5e8b9b4f4f423dad8e9868c63862aa2");
}
// destination Segment
Segment.logEvent("Product Removed from Wishlist", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export default {
  AvoEnv,
  initAvo,
  avoInspectorApiKey,
  productAdded,
  productViewed,
  productListFiltered,
  pageViewed,
  productSearched,
  productListViewed,
  cartViewed,
  checkoutStarted,
  checkoutStepViewed,
  checkoutStepCompleted,
  paymentInfoEntered,
  productRemoved,
  orderPlaced,
  orderCompleted,
  layawayInstallment,
  experimentViewed,
  productClicked,
  modalOpened,
  modalClosed,
  promoClicked,
  promoViewed,
  productAddedToWishlist,
  detailClick,
  quoteFormStarted,
  quoteFormStepCompleted,
  quoteFormCompleted,
  quoteFormSaveDraft,
  appointmentFormStarted,
  appointmentFormStepCompleted,
  appointmentFormCompleted,
  documentWriting,
  productRemovedFromWishlist,
}

// AVOMODULEMAP:"Avo"
// AVOEVENTMAP:["productAdded","productViewed","productListFiltered","pageViewed","productSearched","productListViewed","cartViewed","checkoutStarted","checkoutStepViewed","checkoutStepCompleted","paymentInfoEntered","productRemoved","orderPlaced","orderCompleted","layawayInstallment","experimentViewed","productClicked","modalOpened","modalClosed","promoClicked","promoViewed","productAddedToWishlist","detailClick","quoteFormStarted","quoteFormStepCompleted","quoteFormCompleted","quoteFormSaveDraft","appointmentFormStarted","appointmentFormStepCompleted","appointmentFormCompleted","documentWriting","productRemovedFromWishlist"]
